export type BlogCategory = {
  slug: string;
  name: string;
  title: string;
  description: string;
  intent: string;
};

export const CATEGORIES: BlogCategory[] = [
  {
    slug: "lease-red-flags",
    name: "Lease Red Flags",
    title: "Lease Red Flags: Predatory Clauses to Watch For",
    description:
      "Spot the dangerous, illegal, and one-sided clauses that landlords slip into apartment leases. Plain-English breakdowns of what to refuse before you sign.",
    intent: "[Contract Type] + red flags",
  },
  {
    slug: "lease-explained",
    name: "Lease Explained",
    title: "Lease Agreements Explained: Plain-English Guides",
    description:
      "Every clause, fee, and term in a residential lease — translated from legalese into language you actually understand.",
    intent: "[Contract Type] + explained",
  },
  {
    slug: "lease-templates",
    name: "Lease Templates",
    title: "Free Lease Templates & Sample Agreements",
    description:
      "Download fair, balanced lease templates vetted against tenant-protection laws. Use them as a baseline to negotiate.",
    intent: "[Contract Type] + template",
  },
  {
    slug: "nda-red-flags",
    name: "NDA Red Flags",
    title: "NDA Red Flags: Clauses That Quietly Hurt You",
    description:
      "Spot overbroad scope, indefinite terms, and one-sided remedies in non-disclosure agreements before you sign.",
    intent: "[Contract Type] + red flags",
  },
  {
    slug: "nda-explained",
    name: "NDAs Explained",
    title: "NDAs Explained: What You're Actually Agreeing To",
    description:
      "Plain-English breakdowns of every standard NDA clause — confidential information, term, exclusions, and remedies.",
    intent: "[Contract Type] + explained",
  },
  {
    slug: "nda-templates",
    name: "NDA Templates",
    title: "Free NDA Templates (Mutual & One-Way)",
    description:
      "Balanced mutual and one-way NDA templates you can adapt for freelance projects, partnerships, and pitches.",
    intent: "[Contract Type] + template",
  },
  {
    slug: "freelance-red-flags",
    name: "Freelance Contract Red Flags",
    title: "Freelance Contract Red Flags: Don't Lose Your Pay or Your IP",
    description:
      "Unpaid IP transfers, scope-creep traps, and indefinite revisions — the freelance contract clauses to refuse.",
    intent: "[Contract Type] + red flags",
  },
  {
    slug: "freelance-explained",
    name: "Freelance Contracts Explained",
    title: "Freelance Contracts Explained, Clause by Clause",
    description:
      "What every section of a freelance contract really means — scope, payment terms, IP, kill fees, and termination.",
    intent: "[Contract Type] + explained",
  },
  {
    slug: "freelance-templates",
    name: "Freelance Contract Templates",
    title: "Free Freelance Contract Templates That Actually Protect You",
    description:
      "Battle-tested freelance and independent contractor agreement templates with fair payment, IP, and revision terms.",
    intent: "[Contract Type] + template",
  },
  {
    slug: "employment-red-flags",
    name: "Employment Offer Red Flags",
    title: "Employment Offer Red Flags You Should Negotiate Before Signing",
    description:
      "At-will fine print, clawbacks, broad IP assignments, and non-competes — the offer-letter clauses that cost you most.",
    intent: "[Contract Type] + red flags",
  },
  {
    slug: "employment-explained",
    name: "Employment Contracts Explained",
    title: "Employment Contracts Explained: Offer Letters in Plain English",
    description:
      "Decoding offer letters, employment agreements, equity vesting, and benefits language so you know what you're signing.",
    intent: "[Contract Type] + explained",
  },
  {
    slug: "non-compete-red-flags",
    name: "Non-Compete Red Flags",
    title: "Non-Compete Red Flags That Could Sideline Your Career",
    description:
      "Overbroad geography, multi-year terms, and worldwide industry bans — the non-compete clauses worth fighting.",
    intent: "[Contract Type] + red flags",
  },
  {
    slug: "non-compete-explained",
    name: "Non-Competes Explained",
    title: "Non-Compete Agreements Explained (and When They're Enforceable)",
    description:
      "Plain-English guide to non-competes, non-solicits, and garden leave — including what's enforceable in your state.",
    intent: "[Contract Type] + explained",
  },
  {
    slug: "severance-red-flags",
    name: "Severance Red Flags",
    title: "Severance Agreement Red Flags: What to Push Back On",
    description:
      "Hidden releases, non-disparagement traps, and short signing windows — the severance clauses that quietly cost you.",
    intent: "[Contract Type] + red flags",
  },
  {
    slug: "severance-explained",
    name: "Severance Agreements Explained",
    title: "Severance Agreements Explained: What's Inside and What's Negotiable",
    description:
      "How severance agreements actually work — the release, the consideration, the timeline, and what you can negotiate.",
    intent: "[Contract Type] + explained",
  },
  {
    slug: "tos-red-flags",
    name: "Terms of Service Red Flags",
    title: "Terms of Service Red Flags Most Users Miss",
    description:
      "Class-action waivers, perpetual content licenses, and unilateral changes — the ToS clauses that strip your rights.",
    intent: "[Contract Type] + red flags",
  },
  {
    slug: "tos-explained",
    name: "Terms of Service Explained",
    title: "Terms of Service Explained for Normal Humans",
    description:
      "What ToS agreements actually do, which clauses bind you, and which ones courts won't enforce.",
    intent: "[Contract Type] + explained",
  },
  {
    slug: "privacy-policy-red-flags",
    name: "Privacy Policy Red Flags",
    title: "Privacy Policy Red Flags That Signal Your Data Is the Product",
    description:
      "Vague data sharing, indefinite retention, and broad partner lists — the privacy policy patterns that should worry you.",
    intent: "[Contract Type] + red flags",
  },
  {
    slug: "privacy-policy-explained",
    name: "Privacy Policies Explained",
    title: "Privacy Policies Explained: What Companies Actually Do With Your Data",
    description:
      "How to read a privacy policy in 5 minutes — the sections that matter, the words to search for, and the rights you have.",
    intent: "[Contract Type] + explained",
  },
  {
    slug: "saas-red-flags",
    name: "SaaS Contract Red Flags",
    title: "SaaS Contract Red Flags Buyers Should Reject",
    description:
      "Auto-renewal, uncapped liability, vague SLAs, and data ownership grabs — the SaaS contract clauses to push back on.",
    intent: "[Contract Type] + red flags",
  },
  {
    slug: "saas-explained",
    name: "SaaS Contracts Explained",
    title: "SaaS Subscription Agreements Explained",
    description:
      "MSAs, order forms, SLAs, and DPAs — what each SaaS contract document does and which terms are negotiable.",
    intent: "[Contract Type] + explained",
  },
  {
    slug: "contractor-templates",
    name: "Independent Contractor Templates",
    title: "Independent Contractor Agreement Templates (Free)",
    description:
      "Independent contractor templates with clear scope, payment, and IP terms — for U.S. and remote international work.",
    intent: "[Contract Type] + template",
  },
  {
    slug: "commercial-lease-red-flags",
    name: "Commercial Lease Red Flags",
    title: "Commercial Lease Red Flags Small Businesses Always Miss",
    description:
      "Personal guarantees, CAM creep, percentage rent, and exclusive-use violations — commercial lease clauses to refuse.",
    intent: "[Contract Type] + red flags",
  },
  {
    slug: "commercial-lease-explained",
    name: "Commercial Leases Explained",
    title: "Commercial Lease Agreements Explained for Founders & Owners",
    description:
      "Triple-net vs gross, CAM, TI allowances, and assignment rights — every commercial lease term in plain English.",
    intent: "[Contract Type] + explained",
  },
  {
    slug: "commercial-lease-templates",
    name: "Commercial Lease Templates",
    title: "Commercial Lease Templates & LOI Samples",
    description:
      "Letters of intent and short-form commercial lease templates you can use as a starting point in negotiation.",
    intent: "[Contract Type] + template",
  },
];

export type BlogPost = {
  slug: string;
  category: string; // category slug
  title: string;
  description: string; // meta description, ~155 chars
  excerpt: string; // shown on cards
  keyword: string; // primary SEO keyword
  tags?: string[]; // subtopics for related-post matching
  readTime: string;
  publishedAt: string; // ISO
  updatedAt: string; // ISO
  tldr: string;
  sections: { heading: string; body: string }[];
  faq: { q: string; a: string }[];
  // Optional per-post SEO overrides. When omitted, getPostSeo() derives
  // sensible defaults from `title`, `description`, and `keyword`.
  seoTitle?: string;
  metaDescription?: string;
  canonicalUrl?: string;
  ogImage?: string;
};

export const POSTS: BlogPost[] = [
  // ---------- LEASE RED FLAGS ----------
  {
    slug: "10-apartment-lease-red-flags",
    category: "lease-red-flags",
    title: "10 Apartment Lease Red Flags Every Renter Should Know",
    description:
      "Learn the top 10 lease red flags — from illegal entry clauses to predatory renewal traps — that signal a lease you should refuse to sign.",
    excerpt:
      "From illegal entry clauses to predatory auto-renewals, these are the lease terms that should make you walk away.",
    keyword: "apartment lease red flags",
    tags: [
      "red-flags",
      "entry-notice",
      "security-deposit",
      "auto-renewal",
      "arbitration",
      "fees",
      "negotiation",
    ],
    readTime: "6 min",
    publishedAt: "2026-03-12",
    updatedAt: "2026-04-02",
    tldr: "Look, I've signed enough leases to know the drill — and I've watched enough friends get burned to know which clauses are ticking time bombs. Here's what actually matters when you're sitting there with a pen in your hand and 40 pages of legalese staring back at you.",
    sections: [
      {
        heading: "1. They can walk in basically whenever they want",
        body: "If the lease says the landlord needs only \"reasonable notice\" or — worse — 12 hours or less before entering your apartment, that's a problem. Most states require at least 24 hours. This isn't some minor technicality. It's about whether someone can show up at your door Saturday morning with barely a knock. Yes, there's an exception for genuine emergencies (water pouring through the ceiling, gas smell), and that's fine. What's not fine is \"reasonable notice\" meaning \"we texted you from the parking lot.\"",
      },
      {
        heading: "2. The security deposit is ridiculous",
        body: "Two months' rent is normal. In some states like California or Massachusetts, one month is the legal ceiling. When a landlord asks for three months up front, they're either breaking the law (check your state) or, more often, just trying to grab as much cash as possible on move-in day. Either way, it tells you something about how the relationship's going to go. Even in states with no statutory cap — Texas, Pennsylvania, Colorado — three months is a liquidity play, not a standard practice. Push back.",
      },
      {
        heading: "3. The lease renews itself at a higher price",
        body: "This one is sneaky. Buried somewhere around page 30, you'll find language that says if you don't send written notice 60 days before the lease ends, you're automatically renewed — at a 10 to 15 percent markup, month-to-month. The landlord is betting you'll forget, and a lot of people do. Set a calendar reminder the day you sign, not the week before it expires. The window will have already closed by then.",
      },
      {
        heading: "4. You're on the hook for repairs under some arbitrary dollar amount",
        body: "\"Tenant shall pay for all repairs and maintenance under $300.\" Sounds reasonable? It's not. If your heat goes out in January, that's a habitability issue — and the landlord can't delegate it to you just because the fix happens to cost $250. What they're really trying to do is make you think twice before calling about anything. Don't sign this. The law is on your side in basically every state.",
      },
      {
        heading: "5. You give up your right to sue and let their guy decide everything",
        body: "Mandatory arbitration, where the landlord picks the arbitrator, is about as fair as letting the other team pick the referee. You lose small claims court, you lose discovery, and the person deciding your case is literally paid by the other side. Some states are starting to crack down on this in residential leases, but it's still all over the place. If you strike one thing, strike this.",
      },
      {
        heading: "6. Your roommate bails and you're suddenly responsible for everything",
        body: "Let's be honest — joint-and-several liability isn't some exotic scam. It's in basically every multi-tenant lease and for good reason: the landlord wants one person to chase, not a committee. The red flag isn't the clause itself. It's when the lease buries it without explanation or includes language that lets the landlord pick you specifically as the target while ignoring the roommate who actually skipped town. If you're signing with roommates, everyone needs to understand what they're agreeing to. No excuses.",
      },
      {
        heading: "7. Breaking the lease costs you the entire remaining balance",
        body: '"I want to leave early." "Cool, you owe us the next eight months of rent." This is almost never enforceable because landlords have a legal duty to re-rent the unit — they can\'t just sit on an empty apartment and send you the bill. A fair lease asks for one to two months as a termination fee. A predatory one demands the full term. If you see the latter, it\'s a signal: this landlord doesn\'t plan to act in good faith.',
      },
      {
        heading: "8. You waive your right to a jury trial",
        body: "This one tends to travel with the arbitration clause, and it's just as bad on its own. If a dispute goes to court — and sometimes it should — you want actual jurors, not just a judge, deciding whether the landlord screwed you. Consumer protection cases in particular benefit from a jury. Don't waive this.",
      },
      {
        heading: '9. That "pet fee" never ends',
        body: 'There\'s a difference between a one-time pet deposit (refundable or not, depending on your state) and monthly "pet rent" that adds hundreds to your bill forever. Neither is automatically illegal, but the lease needs to spell out which is which. What\'s predatory is calling something a "pet fee" without making clear it\'s recurring rent by another name. And in states like California, even non-refundable deposits get swallowed into the overall deposit cap. Read the pet language carefully, especially if you have a dog over 30 pounds — the fees tend to balloon fast.',
      },
      {
        heading: '10. The "house rules" aren\'t actually in the lease',
        body: 'If page three references a separate document — "House Rules as amended from time to time" — that the landlord can rewrite whenever they want, you are signing a blank check. Next month, guests might be banned. The month after, parking rules change. You didn\'t agree to any of it, but the lease says you did. At minimum, demand to see the current rules document before signing, and ideally push for language that says changes need your written approval.',
      },
      {
        heading: "Quick gut check before you sign",
        body: "Ask yourself: does this lease read like it was written by someone who expects things to go smoothly between two reasonable adults, or does it read like a pre-negotiated lawsuit? If it's the latter, negotiate or walk. There's always another apartment.",
      },
    ],
    faq: [
      {
        q: "Are these clauses always illegal?",
        a: "Not all of them. Some (like sub-24-hour entry notice or oversized deposits) flat-out break the law in most states. Others are legal but heavily one-sided. Either way, they're worth pushing back on — the worst they can say is no.",
      },
      {
        q: "Can I cross out clauses I don't agree with?",
        a: "Yep. Just make sure both you and the landlord initial each change so it's enforceable. And if a landlord refuses to negotiate any of the basics? That tells you a lot about who you'd be renting from.",
      },
    ],
  },
  {
    slug: "security-deposit-red-flags",
    category: "lease-red-flags",
    title: "Security Deposit Red Flags: When Your Landlord Is Overcharging",
    description:
      "Spot illegal deposit charges, missing escrow, and sketchy deduction language before you hand over the check — and know your leverage.",
    excerpt:
      "If your deposit feels high, it probably is. Here's how to spot illegal charges before you hand over the check.",
    keyword: "security deposit red flags",
    tags: ["red-flags", "security-deposit", "fees", "tenant-rights", "move-out"],
    readTime: "5 min",
    publishedAt: "2026-02-20",
    updatedAt: "2026-03-30",
    tldr: "Every renter knows the security deposit moment. You've found the place, you're excited, and then they hit you with a number that makes you do a double take. But here's the thing — the deposit isn't just a price tag. It's a preview of how the landlord treats money, which is a preview of how they'll treat you.",
    sections: [
      {
        heading: "What's actually legal",
        body: "Deposit limits vary wildly by state, and you should know yours before touring. The rough landscape: California — 1 month's rent for unfurnished, 2 for furnished. Massachusetts — 1 month. New York — 1 month. Texas, Pennsylvania, Colorado — no limit (welcome to Texas). Florida — no limit, but anything excessive gets scrutiny.\n\nEven in no-cap states, nobody normal asks for four months' rent upfront. When someone does, they're either house-poor and using your money to cover their mortgage, or they're setting up a situation where getting the deposit back is going to be a fight. Neither is a landlord you want.",
      },
      {
        heading: "The interest question",
        body: "Some states — about a dozen — require the landlord to hold your deposit in an interest-bearing account and give you the interest. Others require it to be held in a separate account but don't mandate interest. And in a surprising number of states, there's no rule at all. If your lease is silent on where the deposit lives, ask. A landlord who can't or won't answer is probably co-mingling your money with their operating account, which means good luck getting it back when you move out.",
      },
      {
        heading: "The deduction timeline trap",
        body: "Most states give landlords 14 to 30 days after move-out to return your deposit — or at minimum, send you an itemized list of deductions. When a lease pushes that to 45 or 60 days, it's not about processing time. It's about waiting you out and hoping you forget.\n\nReal talk: take photos of everything on move-in day. Every scratch on the floor, every chip in the paint, every stain on the carpet. Email them to yourself so they're timestamped. Do the same on move-out. If the landlord deducts for something you documented as pre-existing, you now have dated proof.",
      },
      {
        heading: "Red flags in the deduction language",
        body: 'Watch for these phrases:\n\n"Landlord may deduct for ordinary wear and tear." No. That\'s illegal everywhere. Wear and tear is the cost of doing business as a landlord. They can only deduct for damage beyond normal use.\n\n"Deposit is non-refundable." Some variation of this shows up in sketchy leases that want to call a fee a deposit. A security deposit is, by definition, refundable. If it\'s not, it\'s a fee, and it needs to be labeled as such. In several states, calling a non-refundable fee a "deposit" is itself a violation.\n\n"Deposit may be applied to any amount landlord claims is owed." This is a blank check clause. Without an itemization requirement or a dispute mechanism, the landlord can just declare the whole deposit forfeited and dare you to do something about it.\n\n"Landlord may use deposit during tenancy for unpaid rent." Your deposit is not a slush fund. If you missed rent, the landlord has an eviction process — they don\'t get to help themselves to the deposit mid-lease and then demand you replenish it immediately.',
      },
      {
        heading: "What to do if you've been overcharged",
        body: "First, confirm your state's actual cap. You can look it up in about three minutes online. If the landlord exceeded it, you have leverage — in many states, knowingly charging an illegal deposit comes with statutory damages: two or three times the overcharged amount, plus attorney's fees. That's not a negotiation tactic. That's a law the landlord should have read.\n\nSecond, don't just refuse to pay. Send an email (you want this in writing) that says something like: \"I noticed the deposit exceeds the [STATE] statutory limit of [AMOUNT]. I'd be happy to proceed at the legal amount.\" Most landlords will back down. The ones who don't are telling you everything you need to know.",
      },
      {
        heading: "The deposit is a relationship test",
        body: "If the deposit terms are fair, transparent, and match state law, you're probably dealing with a professional. If they're not, the lease is going to be full of other problems too. The deposit is the first exchange of money between you and the landlord. If that's already adversarial, the rest of the tenancy will be worse.",
      },
    ],
    faq: [
      {
        q: "What if I already signed?",
        a: "You're not stuck. Take photos and video of every room the day you move in — corners, appliances, that weird stain by the baseboard, all of it. Then send a written request for the deposit 30 days before you leave. If they stiff you, small-claims court is genuinely the easiest part of all this.",
      },
    ],
  },
  {
    slug: "predatory-renewal-clauses",
    category: "lease-red-flags",
    title: "Predatory Lease Renewal Clauses (and How to Negotiate Them Out)",
    description:
      "Auto-renewals, asymmetric notice windows, and holdover penalty explosions — the renewal clauses that quietly cost renters thousands.",
    excerpt:
      "The fine print at the end of your lease can cost you more than the rent itself. Here's what to refuse.",
    keyword: "lease renewal red flags",
    tags: ["red-flags", "auto-renewal", "renewal", "rent-increase", "negotiation"],
    readTime: "6 min",
    publishedAt: "2026-01-15",
    updatedAt: "2026-04-10",
    tldr: "Here's a story I've seen play out too many times. Someone signs a lease in July. The following June, life is busy and they miss a date they didn't even know mattered. Suddenly they're month-to-month at a 15% premium, locked into another year at a price they never agreed to, or out the door in 30 days. These are not accidents. They're designed outcomes — and once you know how the clauses work, they're completely avoidable.",
    sections: [
      {
        heading: "The auto-renewal at higher rent trap",
        body: "This is the most common one. The language usually looks like: \"Upon expiration of the initial term, this Lease shall automatically renew on a month-to-month basis at 110% of the then-current monthly rent, unless Tenant provides written notice of intent to vacate no fewer than 60 days prior to expiration.\"\n\nWhat the landlord is counting on: you'll forget to send that notice because 60 days is a long time before you're actually thinking about moving. You're supposed to decide in April what you're doing at the end of June. Most people don't. And once the clock runs out, you're paying a 10 to 15 percent penalty — often for several months before you even realize it happened because the rent is on autopay.\n\nHow to negotiate: ask for 30 days' notice instead of 60. If they won't budge, the backup plan is simple — set a calendar alert for the notice deadline the same day you sign the lease. Not a mental note. An actual phone notification with a loud sound. Better yet, set two: one a week before the deadline as a warning shot.",
      },
      {
        heading: 'The "we can increase rent mid-lease" clause',
        body: 'Rarer but it shows up, usually in buildings that do "dynamic pricing" like a hotel. The language might say: "Landlord reserves the right to adjust rent with 30 days\' notice during any term of this Lease."\n\nThis defeats the entire point of a fixed-term lease. You locked in for 12 months at a specific price precisely so the cost is predictable. If they want the flexibility to raise prices, they should offer shorter terms — not pretend to offer stability while keeping a trapdoor.\n\nHow to negotiate: strike it entirely. If they insist, ask: "If rent can go up mid-term, can it also go down?" The awkward silence will tell you everything you need to know. This is a one-way clause, and one-way clauses are almost never good for you.',
      },
      {
        heading: 'The "we don\'t have to let you renew" clause',
        body: "Some leases give the landlord the unilateral right to refuse renewal without cause — meaning even if you've been a perfect tenant, they can just decide not to renew and you're out. In rent-controlled or rent-stabilized units, this is usually illegal. In market-rate apartments, it's more complicated and depends heavily on local law.\n\nThe predatory version pairs this with a clause that says you must give 60 days' notice of intent to renew — so you're locked into expressing interest while the landlord can say no at the last minute with no consequence. You're left scrambling for a new place on a compressed timeline.\n\nHow to negotiate: ask for reciprocity. If you have to give 60 days' notice, so should they. If they can refuse renewal, they have to tell you at the same deadline. If they won't agree to reciprocity, at least ask what their historical renewal rate is. A 98% renewal rate is a different risk than 70%.",
      },
      {
        heading: "The holdover penalty explosion",
        body: "\"Holdover\" is what happens when you stay past the end of your lease without signing a new one. A standard holdover penalty is 125% to 150% of rent — enough to motivate you to either sign or leave, but not ruinous. A predatory holdover clause is 200% or 250%.\n\nThese are often unenforceable because courts view them as punitive rather than compensatory, but you don't want to be the person in court explaining that. The landlord is banking on you paying the inflated amount rather than fighting it.\n\nHow to negotiate: cap it at 150%. If they're charging 200%, ask them to justify the number. Most can't — it's a standard-form penalty someone copied from a commercial lease without thinking about it.",
      },
      {
        heading: "The hidden renewal offer window",
        body: 'Some corporate landlords send renewal offers with an expiration date. Missing that date doesn\'t necessarily mean you lose the unit — but it can mean the offered price is now "subject to change." And change it will: the new offer will be higher because they know you\'re under time pressure.\n\nHow to negotiate: this one is less about changing lease language and more about process. Ask up front: "When do you typically send renewal offers, and how long do I have to respond?" The normal answer is 60 to 90 days before expiration with a 15 to 30 day response window. Anything shorter is designed to rush you.',
      },
      {
        heading: "When to walk away",
        body: "Some renewal clauses are negotiable. Some aren't. And some are signals that the landlord's entire business model depends on squeezing tenants who don't read the fine print.\n\nIf you see an auto-renewal at high rent paired with a long notice period, plus an asymmetric renewal refusal right, plus a punitive holdover penalty — that's not an accident. That's an integrated system designed to extract maximum revenue from the gap between what you signed and what you'll actually track.\n\nYou won't change their business model in a lease negotiation. You'll either get the clauses softened or you'll find a landlord who doesn't need to trick tenants into profitability. The good ones exist. They just don't run as many ads.\n\nThe one calendar reminder that saves you: the day you sign, pull out your phone and set a notification for 75 days before the lease ends. It'll take fifteen seconds and it'll save you a minimum of a month's worth of penalty rent. Do it now, while you're thinking about it.",
      },
    ],
    faq: [
      {
        q: "How early should I get a renewal offer?",
        a: "Aim for 60–90 days before your lease ends. That gives you real time to compare prices, weigh moving costs, and actually negotiate — instead of saying yes to whatever lands in your inbox the week before you'd have to start packing.",
      },
    ],
  },

  // ---------- LEASE EXPLAINED ----------
  {
    slug: "residential-lease-explained",
    category: "lease-explained",
    title: "Residential Lease Agreement Explained (Section by Section)",
    description:
      "A plain-English walkthrough of every section in a standard residential lease — terms, fees, obligations, and where landlords add risk.",
    excerpt:
      "Open any lease and you'll find the same 12 sections. Here's exactly what each one means.",
    keyword: "residential lease explained",
    tags: [
      "explained",
      "lease-sections",
      "rent",
      "fees",
      "security-deposit",
      "entry-notice",
      "maintenance",
      "termination",
    ],
    readTime: "5 min",
    publishedAt: "2026-02-08",
    updatedAt: "2026-04-15",
    tldr: "The first time I opened a real lease, I think I read the first two pages, got bored, and just started signing wherever there was a blank line. I'm guessing that's how most people do it. And honestly, I get it. Leases are boring. They're written in a language nobody actually speaks. But here's the thing: once you know what the sections actually do, you can skim one in about ten minutes and spot the problems.\n\nSo here's every section you'll find in a standard residential lease, and what actually matters in each one.",
    sections: [
      {
        heading: "Parties",
        body: "This is just who's involved. You, the landlord, maybe a property management company. Boring, right? Except for this: every adult living in the apartment should be named. If your partner or your cousin is staying with you and they're not on the lease, you're technically violating it before you even move in. And if something goes wrong — an eviction, damage, whatever — the landlord has more leverage because there are unnamed occupants. Just list everyone.",
      },
      {
        heading: "Premises",
        body: "This says what you're actually renting. Address, unit number, and crucially, what's included. Parking spot? It should be here. Storage unit in the basement? Here. That nice washer and dryer that sold you on the place? If it's not listed as included, the landlord can take it out next week and you have no recourse.\n\nI learned this one the hard way. Apartment I rented had a parking spot behind the building. Not in the lease. Six months in, the landlord sold the spot to a neighbor for extra income. I was parking on the street for the rest of the year.",
      },
      {
        heading: "Term",
        body: "Start date, end date. Seems obvious. But pay attention to mid-month dates. If your lease starts on the 15th, is the first month prorated? Some leases assume full payment. And watch how the end date interacts with your notice obligations — if you need to give 60 days' notice and the lease ends on an odd date, the math gets weird.",
      },
      {
        heading: "Rent and Fees",
        body: "The monthly number, when it's due, the grace period, and what happens if you're late. Late fees are regulated in many states — if your lease says 10% of rent as a late fee, check your state law because that might be double what's allowed. Also: what payment methods are accepted? If they only take money orders and you've been paying by check, they can technically reject your payment and start the eviction clock.",
      },
      {
        heading: "Security Deposit",
        body: "How much, where it's held, and how you get it back. The lease SHOULD reference your state's deposit return statute. If it doesn't mention one at all, that's not automatically illegal but it's a sign the landlord either doesn't know the law or doesn't care. Either way, take photos of everything on move-in day.",
      },
      {
        heading: "Utilities",
        body: "Who pays for what. Water, gas, electric, internet, trash. If something is shared between units (like a common water heater), the lease should explain how it's divided. If it's silent, assume you're paying for the whole building's hot water.",
      },
      {
        heading: "Use of Premises",
        body: "What you can and can't do in the apartment. This is where you'll find clauses about running a business from home, having overnight guests for more than X days, whether you can paint the walls, subletting restrictions. Read this one carefully. The guest policy in particular can be a trap — if the lease says no guest for more than 7 consecutive days, and your mom comes to visit for 10 days, you're in violation.",
      },
      {
        heading: "Maintenance and Repairs",
        body: "Who fixes what. The landlord is legally responsible for habitability: heat, water, plumbing, electricity, structural integrity. That obligation exists whether or not the lease spells it out. What the lease adds is YOUR responsibilities — changing lightbulbs, keeping the place reasonably clean, reporting problems promptly. Watch for clauses that try to push habitability repairs onto you.",
      },
      {
        heading: "Landlord Entry",
        body: 'When they can come in, how much notice they have to give, and what counts as a valid reason. 24 hours is the floor in most states. A clause that says "reasonable notice" is a red flag because "reasonable" means whatever the landlord says it means in the moment.',
      },
      {
        heading: "Default and Termination",
        body: "What happens when something goes wrong. What counts as a breach? How many days do you get to fix it before you're considered in default? And what happens after that — eviction process, acceleration of rent, penalties? This section is usually dense but it's the one that matters most when things go sideways.",
      },
      {
        heading: "Signatures",
        body: "Everyone signs. Everyone initials each page ideally. If the landlord initials changes you made (like crossing out a clause), those changes are enforceable. If you just cross something out and sign without the landlord acknowledging it, you're in a gray area you don't want to be in.",
      },
    ],
    faq: [
      {
        q: "What if a section is missing?",
        a: "State law fills the gap. Sometimes that's fine, sometimes it's not. If the security deposit section is missing, for example, your state probably has default rules that cover it — but you'd have to look them up to know what they are.",
      },
      {
        q: "What if the lease conflicts with state law?",
        a: "State law wins. Always. The problem is you might not know there's a conflict until a dispute happens and a lawyer or judge points it out. That's why it's worth knowing your state's basics before you sign.",
      },
    ],
  },
  {
    slug: "lease-fees-explained",
    category: "lease-explained",
    title: "Every Lease Fee Explained: What's Legal, What's Not",
    description:
      "Application fees, pet rent, amenity fees, late fees, admin fees — what each one actually covers and which ones you can refuse.",
    excerpt:
      "Landlords have invented dozens of fees. Most are negotiable; a few are illegal. Here's the breakdown.",
    keyword: "lease fees explained",
    tags: ["explained", "fees", "late-fees", "pet-rent", "negotiation"],
    readTime: "6 min",
    publishedAt: "2026-03-01",
    updatedAt: "2026-04-20",
    tldr: 'The first apartment I ever rented came with a $75 application fee, a $300 "administrative fee," a $50 "move-in fee," and — I\'m not making this up — a $40 "key processing fee" for the two keys they handed me. I paid it all because I didn\'t know any better. Now I know: most of those fees are either negotiable, inflated, or outright illegal depending on where you live.\n\nHere\'s the rundown of every fee you\'re likely to see, what\'s normal, and what should make you pause.',
    sections: [
      {
        heading: "The Application Fee",
        body: "This covers the actual cost of running your credit and background check. Those checks typically cost the landlord $30 to $50. If the fee is $75 or higher, you're being charged more than the screening costs. Some states cap application fees by law. California, for instance, says they have to reflect the actual cost and caps annual increases.\n\nThe thing is, even if the fee is reasonable, you're paying for a service. If you get denied, you have the right under the Fair Credit Reporting Act to request the actual screening report the landlord used. Most people don't know this. Most landlords hope you don't know this. If you ever suspect you were denied unfairly — for example, you have great credit and a clean background but got rejected anyway — request the report. It'll tell you what they actually saw.",
      },
      {
        heading: "The Administrative Fee",
        body: "This is the big one. It can range from $150 to $500 and it's almost always non-refundable. What does it actually pay for? In theory, paperwork, processing time, maybe setting up your tenant portal. In practice, it's almost pure profit. The landlord is charging you for the privilege of renting from them.\n\nI always push back on admin fees. Sometimes I get them reduced by half. Sometimes I get them waived entirely. When I ask \"what does this actually cover,\" I've gotten answers ranging from a detailed breakdown (fine, I'll pay it) to a shrug (I ask for it to be removed). The shrug is more common.",
      },
      {
        heading: "The Move-in Fee",
        body: "Sometimes this is a separate line item, sometimes it's bundled into the admin fee. It supposedly covers the cost of preparing the unit — cleaning, minor repairs, whatever. The thing is, your rent already covers the cost of maintaining the unit. This is a double charge.\n\nIf the move-in fee is non-refundable (it usually is) and the lease also has a security deposit, you're effectively paying twice for the same eventual purpose: covering potential costs when you leave. I've had success negotiating move-in fees by pointing out that the security deposit already covers any damage I might cause.",
      },
      {
        heading: "The Late Fee",
        body: "Most leases have a grace period — typically 3 to 5 days after the due date — before late fees kick in. After that, the fee is usually a flat dollar amount or a percentage of rent. 5% is common. 10% starts to get into territory some states explicitly forbid.\n\nLate fees are regulated by state law, and many states require them to be a \"reasonable estimate\" of the landlord's actual costs from your late payment. A landlord's actual cost for receiving rent 5 days late is basically zero. So a $200 late fee on a $2,000 apartment is probably not reasonable — and in some states, a court would strike it.",
      },
      {
        heading: "Pet Fees, Pet Rent, and Pet Deposits",
        body: 'Okay, this is the one where things get complicated. There are three types of pet charges:\n\nPet deposit: One-time, usually refundable if there\'s no pet damage when you move out. In some states (like California), even "non-refundable" pet deposits get counted toward the overall deposit cap, so the distinction matters less.\n\nPet rent: Monthly, never refundable, usually $25 to $75 per pet. This is just additional rent under a different name. It doesn\'t cover anything specific — it\'s just revenue for the landlord.\n\nPet fee: This is the ambiguous one. Some landlords use "pet fee" to mean a one-time non-refundable charge. Others use it to mean monthly pet rent. The lease should clearly state which it is. If it doesn\'t, ask.\n\nI have a 60-pound dog and I\'ve seen charging schemes that would make a car dealership blush. The worst was a $500 "pet deposit" (non-refundable, despite the word "deposit") plus $100/month in "pet rent" — $1,700 over a year, just for the dog to exist. I walked. A few months later I found a place with a $300 refundable deposit and no monthly rent. The deals exist if you\'re patient.',
      },
      {
        heading: "Amenity Fees",
        body: "Gym, pool, package lockers, rooftop access — some buildings charge separately for these instead of bundling them into rent. The key question: can you opt out? If you never use the gym, you shouldn't be paying for it. But some leases make amenity fees mandatory whether you use the amenities or not.\n\nI've had luck negotiating these by saying \"I don't use X, can we strike that fee.\" Sometimes the answer is yes. Sometimes it's \"no, it's a building-wide charge.\" But asking costs nothing and occasionally saves you $50 a month.",
      },
      {
        heading: "Utility Administration Fees",
        body: "Some buildings use third-party billing services for utilities. These companies — like Conservice or SimpleBills — charge a monthly administration fee on top of your actual usage. We're talking $5 to $15 a month for the privilege of getting a bill.\n\nThe fee itself isn't the problem. The problem is when the lease doesn't mention it at all and suddenly you're paying extra every month for something you never agreed to. The lease should disclose any billing admin fees upfront.",
      },
      {
        heading: "Trash and Valet Waste Fees",
        body: "Some buildings contract with a valet trash service that picks up your garbage from outside your door. Convenient? Sure. But the monthly fee — usually $25 to $50 — is mandatory even if you'd rather walk your trash to the dumpster yourself. This is another one that sometimes isn't disclosed in the lease itself, only in an addendum or community policies document. Ask before you sign.",
      },
    ],
    faq: [
      {
        q: "Can I get my application fee back if I'm denied?",
        a: "Generally no, because it covered the actual screening cost. But you CAN request a copy of the screening report under the FCRA. If the landlord refuses, that's a violation.",
      },
      {
        q: "What's the best way to push back on fees?",
        a: 'Point to comparables. "I looked at three other buildings in this neighborhood and none of them charge an admin fee. Can we reduce or waive it?" Landlords respond to market pressure, not arguments about fairness.',
      },
    ],
  },
  {
    slug: "tenant-rights-explained",
    category: "lease-explained",
    title: "Your Tenant Rights Explained (State-by-State Summary)",
    description:
      "A clear summary of tenant rights in all 50 states — entry notice, deposit limits, repair obligations, and eviction protections.",
    excerpt:
      "Your rights as a tenant don't depend on what your lease says — they depend on where you live.",
    keyword: "tenant rights explained",
    tags: [
      "explained",
      "tenant-rights",
      "entry-notice",
      "security-deposit",
      "habitability",
      "eviction",
    ],
    readTime: "5 min",
    publishedAt: "2026-01-22",
    updatedAt: "2026-04-25",
    tldr: "Here's something most renters don't realize: your rights don't come from your lease. They come from state law. The lease can add protections, but it can't take away what the law already gives you. And every state gives you more than you probably think.\n\nI'm not going to list all 50 states here — that would take forever and half of it would be out of date by the time you read it. Instead, here are the four rights that exist in basically every state, plus how to find the specifics for yours.",
    sections: [
      {
        heading: "The Implied Warranty of Habitability",
        body: "This is the big one. It means your landlord has to provide a place that's actually livable. Working heat in winter. Running water. Functional plumbing. Electricity. A roof that doesn't leak. No infestations that make the place unsafe.\n\nThis isn't something the landlord can opt out of. It's implied by law. Even if your lease says \"tenant accepts the unit as-is,\" that doesn't waive the habitability requirement. If the heat goes out in January, the landlord has to fix it, period.\n\nI once lived in a building where the boiler broke during a cold snap in Chicago. The landlord dragged his feet for a week. I looked up the local tenant ordinance, found the relevant section about heating requirements, and sent him an email quoting the statute and the fine schedule. Got a space heater within hours and a permanent fix within two days. Sometimes you just have to show them you know the rules.",
      },
      {
        heading: "Right to Quiet Enjoyment",
        body: "This sounds fancy but it basically means the landlord can't harass you or constantly disrupt your life. They can't show up unannounced. They can't enter your apartment for no reason. They can't make your living situation unbearable on purpose to pressure you into leaving.\n\n\"Quiet enjoyment\" is a legal term with a long history, but practically it means you have the right to live in your apartment without being bothered unreasonably. Repeated unannounced entries, cutting off utilities to force you out, or making threats all violate this right.\n\nThe notice requirement for entry is part of this. In most states, it's 24 hours. The landlord has to give you that much heads-up unless there's a genuine emergency — fire, flood, gas leak. \"I wanted to check on something\" is not an emergency.",
      },
      {
        heading: "Protection from Retaliatory Eviction",
        body: "If you complain to the health department about a mold problem, or you report a code violation, or you join a tenants' union, the landlord cannot evict you in retaliation. Most states have a protected window — usually 90 to 180 days after you make a complaint — during which any eviction or rent increase is presumed retaliatory.\n\nThis is a powerful protection that not enough renters know about. If you're in a dispute with your landlord and suddenly they're trying to evict you on some technicality, the timing matters. Document everything. Note when you made the complaint, note when the eviction notice arrived. The proximity is evidence.",
      },
      {
        heading: "Deposit Return Rules",
        body: "Every state has rules about how quickly the landlord has to return your deposit or provide an itemized list of deductions. Usually it's 14 to 30 days. Some states have strict penalties for late returns — double or triple damages plus attorney's fees.\n\nThe landlord also has to give you the deposit back in a specific way. Some states require interest. Some require the deposit to be held in a separate account. Some require both. If your landlord can't tell you where your deposit is held, that's a problem.",
      },
      {
        heading: "How to Find Your State's Laws",
        body: "The best search query is: \"[your state] residential landlord-tenant act.\" The state attorney general's website usually has a plain-English summary. Legal aid organizations in your state also publish tenant rights handbooks that are much easier to read than the actual statutes.\n\nDon't rely on Reddit posts or TikTok videos for this stuff. Laws change — sometimes recently. California has significantly strengthened tenant protections in the past few years. New York passed major reforms in 2019. Other states are updating their laws regularly. What was true five years ago might not be true today.",
      },
    ],
    faq: [
      {
        q: "Do these rights apply if I'm renting a room, not an apartment?",
        a: "Generally yes, but the specifics vary. In some states, room rentals where you share a kitchen or bathroom with the landlord have different rules — usually weaker protections. Check your state's specific carve-outs.",
      },
      {
        q: "What if the lease says I waive these rights?",
        a: "In most cases, you can't waive statutory rights. A clause saying \"tenant waives the right to a habitable unit\" is unenforceable. Courts don't let landlords contract around basic protections.",
      },
    ],
  },

  // ---------- LEASE TEMPLATES ----------
  {
    slug: "fair-residential-lease-template",
    category: "lease-templates",
    title: "Fair Residential Lease Template (Free Download)",
    description:
      "A balanced, attorney-reviewed residential lease template that protects both tenant and landlord. Free to download and customize.",
    excerpt:
      "A balanced lease that protects both parties. Use it as your baseline when negotiating.",
    keyword: "residential lease template",
    tags: [
      "template",
      "lease-sections",
      "security-deposit",
      "entry-notice",
      "renewal",
      "negotiation",
    ],
    readTime: "4 min",
    publishedAt: "2026-02-14",
    updatedAt: "2026-04-18",
    tldr: "I've signed leases that were clearly downloaded from some sketchy website in 2003, printed on a dot-matrix printer, with clauses that hadn't been legal in any state for a decade. I've also signed leases that were clearly drafted by an actual lawyer who does this for a living. The difference is night and day — and it's not about page count. It's about balance.\n\nThe template we're offering here isn't some generic form letter. It's built around a simple principle: a lease should protect both parties, not just the person who wrote it. If you're a landlord, it protects your property and your income. If you're a tenant, it protects your deposit, your privacy, and your right to a habitable home.",
    sections: [
      {
        heading: "What's in It",
        body: "The standard twelve sections, obviously — parties, premises, term, rent, security deposit, utilities, use, maintenance, entry, default, termination, signatures. Each one written in actual English, not whatever language lawyers speak when they're billing by the hour.\n\nBut beyond the basics, it includes the stuff that separates a fair lease from a predatory one. 24-hour entry notice, written explicitly. A security deposit held in a separate account with a clear return timeline. A renewal clause that doesn't punish you for forgetting a deadline. Late fees capped at what's actually reasonable. Maintenance responsibilities clearly divided between what the landlord handles (everything that keeps the place livable) and what the tenant handles (lightbulbs, air filters, basic upkeep).\n\nThere's also a state-law conformity rider. This is important because the baseline template can't possibly account for every state's quirks. Massachusetts has different deposit rules than Texas. California has different renewal protections than Florida. The rider helps you adapt the template to where you actually live.",
      },
      {
        heading: "How to Use It",
        body: "Download the file. Fill in the bracketed fields — names, dates, amounts, addresses. Have both parties initial every page. This isn't just ceremony; it prevents someone from claiming later that you swapped a page. If you made any changes — crossed out a clause, modified a deadline, adjusted a fee — both parties need to initial next to those changes.\n\nThen, and this is the step most people skip, actually confirm that the terms align with your state's current law. Search \"[your state] landlord-tenant act\" and skim the sections about deposits, entry notice, and late fees. If anything conflicts, the template is meant to be adjusted. It's a starting point, not gospel.",
      },
      {
        heading: "When to Call a Lawyer",
        body: "This template covers the vast majority of standard residential rental situations. But there are situations where you should absolutely pay for a legal review:\n\n- Rent-controlled or rent-stabilized units. These come with additional protections and obligations that a general template won't cover.\n- Section 8 or other subsidized housing programs. Different rules, different paperwork.\n- Mixed-use spaces where you're living AND running a business. Residential and commercial law interact in ways that are genuinely complicated.\n- Any situation where a significant amount of money is at stake. If the annual rent is high enough that a dispute would be financially serious, a one-hour legal review is cheap insurance.\n\nTemplates are great. I use them myself. But they're a starting point, not legal advice, and if you ever find yourself thinking \"I'm not sure if this applies to my situation,\" the answer is probably \"ask someone who does this for a living.\"",
      },
    ],
    faq: [
      {
        q: "Is this template legally binding?",
        a: "Yes, once both parties sign and date it, and any required notarization is completed. But again — it's a template, not a custom legal document for your specific situation.",
      },
      {
        q: "Can I use this for subletting?",
        a: "No. Sublets need different language — they reference the master lease and typically require landlord consent. We have a separate sublease template for that scenario.",
      },
    ],
  },
  {
    slug: "month-to-month-lease-template",
    category: "lease-templates",
    title: "Month-to-Month Lease Template (Free)",
    description:
      "A simple, fair month-to-month lease template with proper termination notice, rent change rules, and tenant protections.",
    excerpt: "Simpler than a year lease, but with all the protections you need.",
    keyword: "month to month lease template",
    tags: ["template", "month-to-month", "termination", "rent-increase", "habitability"],
    readTime: "3 min",
    publishedAt: "2026-03-18",
    updatedAt: "2026-04-22",
    tldr: "A year-long lease feels safe. You know your rent, you know your move-out date, and you know the landlord can't change anything for twelve months. But sometimes a year is too long. Maybe you're new to a city and want to feel it out. Maybe you're between life stages and your plans are genuinely uncertain. Or maybe you just don't want to be locked into anything.\n\nA month-to-month lease gives you flexibility. But it also gives the landlord flexibility, and that's what makes people nervous. A month-to-month tenant can be asked to leave with relatively short notice, and the rent can change with relatively short notice too. That uncertainty is the price of freedom.",
    sections: [
      {
        heading: "Key Differences from a Year Lease",
        body: "No fixed end date. The lease continues indefinitely until either party gives notice to end it. In most states, that notice is 30 days. Some states require more — sometimes 60 days if you've been there a long time.\n\nRent can change. But — and this is crucial — it can only change with proper written notice. Usually the same notice period as termination: 30 days in most places. Some states require 60 days for increases over a certain percentage. If your landlord sends you a text on the 15th saying \"rent goes up next month,\" that's almost certainly not proper notice.\n\nEverything else is the same. The unit still has to be habitable. The landlord still has to give 24 hours' notice before entering. The security deposit still follows the same rules. A month-to-month lease doesn't mean month-to-month rights.",
      },
      {
        heading: "Required Notices",
        body: "Termination: usually 30 days in writing. Doesn't have to be fancy — an email or a letter works. But verbal doesn't count. \"I told the super I was leaving\" is not notice under any state's law.\n\nRent increase: similar timeline. For increases under 10%, 30 days is standard. For bigger jumps, some states require 45 or 60 days. The template includes language that forces the landlord to follow whatever your state requires, not just whatever they feel like.",
      },
      {
        heading: "Who This Is For",
        body: "Someone testing a new city. Someone between leases and not ready to commit. Someone who might need to relocate for work on short notice. Also landlords who want flexibility — subletters, short-term tenants, or situations where the property might be sold.\n\nIt's not for someone who needs price certainty. If knowing your exact rent for the next 12 months matters to your budget, get a fixed-term lease. The month-to-month discount rarely compensates for the stress of unpredictable costs.",
      },
    ],
    faq: [
      {
        q: "Is month-to-month riskier than a year lease?",
        a: "It's more flexible, which cuts both ways. You can leave whenever, but so can the landlord. If price stability matters to you, go with a fixed term.",
      },
    ],
  },
  {
    slug: "roommate-lease-template",
    category: "lease-templates",
    title: "Roommate Lease Agreement Template (Free)",
    description:
      "A roommate agreement template covering rent splits, chores, guests, and conflict resolution — separate from your master lease.",
    excerpt:
      "The agreement that prevents the worst kind of fights — between people who share a kitchen.",
    keyword: "roommate lease template",
    tags: ["template", "roommates", "rent", "security-deposit", "move-out"],
    readTime: "4 min",
    publishedAt: "2026-03-25",
    updatedAt: "2026-04-26",
    tldr: "I've had good roommates and bad roommates. The good ones paid rent on time, did their dishes, and communicated like adults. The bad ones... let's just say I've Venmo-requested someone for utilities for six consecutive months with zero response. The difference between a good and bad roommate situation usually comes down to one thing: whether you had clear agreements in writing before anything went wrong.",
    sections: [
      {
        heading: "What to Cover",
        body: "Rent. This seems obvious but it's where things get weird. Does everyone pay equal shares? Does the person with the bigger bedroom pay more? Is it per room, per person, or per square foot? Write it down. Don't do the \"we'll figure it out\" thing because you won't, and the first person who gets a smaller than expected paycheck will suddenly feel very strongly about the \"fairness\" of the split.\n\nUtilities. Who pays which bills? Are they all in one person's name with everyone else reimbursing them? What's the deadline for reimbursement — within a week of the bill arriving? Within 24 hours? Set a hard deadline because floating your roommate's share of the electric bill for three weeks while they \"get around to it\" is slowly corrosive to any friendship.\n\nDeposits. If you all contributed to a security deposit, how does it get divided when people leave? If one person moves out mid-lease and a new person moves in, the new person should pay their share of the deposit to the departing roommate, not to the landlord. The lease should document this flow of money so nobody's left holding the bag.\n\nCommon areas and chores. I'm serious. Yes, it feels weird to write down \"Kitchen: clean your own dishes within 24 hours.\" But three months in, when someone has left a pan soaking for the fifth day in a row, you'll be glad there's something to point at that isn't just your growing resentment.\n\nGuests. How long can someone stay before they're basically a roommate who should be paying rent? A week? Two weeks? Does this apply to significant others? (It should. Everyone's significant other becomes a de facto fifth roommate eventually.)\n\nQuiet hours. Especially if you work different schedules. If one person works nights and sleeps during the day, and another person likes to vacuum at 10am, you have a structural conflict. Address it now.\n\nMove-out procedures. How much notice does someone give before moving out? (30 days is standard.) Who finds the replacement? How is the deposit handled between the old and new roommate?",
      },
      {
        heading: "Conflict Resolution",
        body: 'Include a simple mediation step. Something like: "If a dispute arises, the roommates agree to discuss it at a scheduled house meeting within 7 days before involving any outside parties." This sounds silly, but the simple act of scheduling a conversation prevents the kind of impulsive "I\'m moving out next week, good luck" moments that blow up housing situations.',
      },
      {
        heading: "Is This Enforceable?",
        body: "Between the roommates who sign it — yes. It's a contract like any other. If someone breaches it and you end up in small claims court, a signed roommate agreement with specific dollar amounts is the kind of evidence judges love.\n\nIt does NOT bind the landlord. The landlord only cares about the master lease. But it binds the roommates to each other, and in a multi-tenant situation, that's usually where the problems actually happen.",
      },
    ],
    faq: [
      {
        q: "What if someone refuses to sign?",
        a: "That's a red flag. If someone won't commit to basic, written agreements about money and responsibilities, they're telling you how they'll handle conflict before you've even moved in together. Believe them.",
      },
    ],
  },

  // ---------- NDA RED FLAGS ----------
  {
    slug: "nda-red-flags-to-watch-for",
    category: "nda-red-flags",
    title: "10 NDA Red Flags You Should Never Ignore",
    description:
      "From indefinite terms to non-solicits hidden inside an NDA — the 10 clauses that should make you pause before you sign.",
    excerpt:
      "An NDA can quietly restrict your career for years. These are the 10 patterns that signal you should renegotiate.",
    keyword: "NDA red flags",
    tags: ["red-flags", "nda", "scope", "term", "non-solicit", "remedies", "negotiation"],
    readTime: "5 min",
    publishedAt: "2026-04-01",
    updatedAt: "2026-04-22",
    tldr: "I've signed NDAs before job interviews, before freelance calls, before coffee meetings that went absolutely nowhere. Most of them were fine. A few made me stop and email back: \"Hey, a couple of things in here I want to flag.\"\n\nThe thing about NDAs is they look harmless. Two pages, maybe three. No money involved. Just \"don't share our secrets.\" Why would you push back on that? Because tucked into those two pages are clauses that aren't about secrecy at all. They're about restricting what you can do for years after the conversation is over.\n\nHere's what actually matters.",
    sections: [
      {
        heading: '1. Confidential Information Defined as "all Information Shared"',
        body: "A fair NDA defines confidential information specifically — technical data, customer lists, financials — and ideally limits it to information that's marked or identified as confidential at the time it's shared. A bad one says \"all information, whether oral or written, regardless of form or marking.\"\n\nThat sounds like a minor distinction. It's not. If the definition covers everything, then even publicly known facts could technically be a breach if you mention them. A client's name that's listed on their own website. Their industry, which is obvious from five seconds of Googling. The NDA treats everything as secret, which means the other party can claim a breach anytime they feel like it.\n\nPush for a definition that ties confidentiality to marking, or at minimum, to information a reasonable person would treat as confidential. \"All information\" is a blank check.",
      },
      {
        heading: "2. No Carve-outs for Public, Prior, or Independently Developed Information",
        body: "Every well-drafted NDA has four standard exclusions. Information that:\n\n- Becomes public through no fault of yours\n- You already knew before signing\n- You independently developed without using the disclosed information\n- You received from a third party who had no obligation of confidentiality\n\nIf any of these are missing, it's a problem. Without the public-domain exclusion, you could violate the NDA by discussing something that was reported in the Wall Street Journal. Without the prior-knowledge exclusion, the other side could claim you're bound by an NDA for information you knew years before signing it. Missing carve-outs aren't drafting oversights — they're traps.",
      },
      {
        heading: "3. Indefinite or 10+ Year Duration",
        body: 'Typical NDA terms are 3 to 5 years. Information loses value over time. Markets change. Technology moves on. A 3-year NDA covers the useful life of most business secrets.\n\nA 10-year or indefinite NDA is something else. It\'s a permanent restriction on what you can discuss, about a company you might have interacted with for a single meeting. I once saw an NDA with a "perpetual" term from a startup that had existed for about 18 months. Their secrets were not that valuable. They were just using the NDA as a blanket.\n\nTrade secrets — actual trade secrets — can survive indefinitely. But those should be identified as trade secrets in the NDA, not treated as the default for every piece of information shared.',
      },
      {
        heading: "4. Hidden Non-solicit or Non-compete Language",
        body: "An NDA governs information. That's it. If you see language about not soliciting employees, not hiring contractors, or not competing with the other party — that's not confidentiality. That's a restraint of trade, hiding inside a document it doesn't belong in.\n\nThese clauses often look like: \"Receiving party shall not directly or indirectly solicit, hire, or engage any employee, customer, or contractor of Disclosing Party for a period of X years.\" This is unrelated to secrecy. It's about limiting your business activity, and it should be negotiated separately or struck entirely.",
      },
      {
        heading: "5. Liquidated Damages or One-way Attorney Fee Shifting",
        body: "Some NDAs say that if you breach the agreement, you owe a fixed amount — say $50,000 — regardless of actual harm. This is called liquidated damages, and in the context of a casual NDA, it's absurd.\n\nEqually problematic: a clause saying that in any dispute, you pay the other side's legal fees, but they don't pay yours even if you win. This discourages you from ever pushing back on a claim, because the cost of defending yourself might exceed whatever you'd lose by just settling.",
      },
      {
        heading: "6. Distant Choice of Law or Venue",
        body: "If you're in Chicago and the NDA says disputes are governed by Delaware law and must be litigated in Delaware courts, your cost to defend yourself just tripled before any arguments are even heard. The other side is betting you won't travel across the country, hire local counsel, and fight it.\n\nNegotiate for your home state's law and venue, or at minimum, a neutral forum. If you live in California and they're in New York, Delaware might actually be neutral. But if they're based in Delaware and chose Delaware, that's not neutral — it's home-field advantage.",
      },
    ],
    faq: [
      {
        q: "Can I just sign it and not worry about it?",
        a: "For a one-off meeting about a project that never goes anywhere, probably nothing happens. But NDAs can surface years later — you start a company, you hire someone, and suddenly an old NDA with a non-solicit clause is relevant. Negotiate it now when it costs you nothing.",
      },
      {
        q: "Do big companies actually negotiate NDAs?",
        a: "Yes. They expect redlines. The first draft is never the final draft.",
      },
    ],
  },
  {
    slug: "mutual-vs-one-way-nda-red-flags",
    category: "nda-red-flags",
    title: "Mutual vs One-Way NDA: Red Flags in Each",
    description:
      "When a one-way NDA is acceptable, when it isn't, and the specific clauses to watch for in mutual agreements.",
    excerpt:
      "Whether you sign a mutual or one-way NDA matters less than the specific clauses inside it. Here's what to scan for in each.",
    keyword: "mutual vs one way NDA",
    tags: ["red-flags", "nda", "mutual-nda", "negotiation"],
    readTime: "3 min",
    publishedAt: "2026-04-04",
    updatedAt: "2026-04-23",
    tldr: "Most NDAs come in two flavors. A mutual NDA says both sides promise not to share each other's secrets. A one-way NDA says only one side is bound — the other can do whatever they want with what they learn.\n\nThe structure matters less than people think. A mutual NDA can still be terrible if it's lopsided in other ways. A one-way NDA can be totally fine if you're not sharing anything sensitive. Here's what to actually look for in each.",
    sections: [
      {
        heading: "When a One-way NDA Makes Sense",
        body: "Job interviews. You're learning about their roadmap, their tech stack, their challenges. You're not disclosing anything sensitive (or you shouldn't be — don't share your current employer's secrets). A one-way NDA here is normal and expected.\n\nContractor onboarding. They're giving you access to their systems, their codebase, their business plans. You're the one receiving information. Makes sense.\n\nDue diligence. You're evaluating their business as a potential investor or acquirer. They're opening the books. You're just looking.\n\nThe test is simple: are you sharing anything you'd be upset about if it became public? If the answer is genuinely no, a one-way NDA is fine.",
      },
      {
        heading: "When It Isn't",
        body: "Pitching investors. You're sharing your deck, your financials, your roadmap. If the NDA only binds you — protecting the investor's irrelevant \"process\" while leaving your actual business exposed — you're the only one at risk. Insist on mutual, or at least negotiate that the investor won't use your information to compete.\n\nPartner discussions. You're both sharing roadmaps, customer lists, technical specs. If the NDA is one-way, one side is getting protection and the other is getting nothing. That's not a partnership — that's information extraction.\n\nThe red flag here isn't the one-way structure itself. It's when a one-way NDA is presented in a situation where both sides are clearly sharing sensitive information. That means either the other side doesn't view your information as valuable, or they're planning to use it and don't want to be constrained.",
      },
      {
        heading: "Sneaky Mutual NDA Clauses",
        body: "A mutual NDA is supposed to treat both sides equally. But I've seen \"mutual\" NDAs that define one party's confidential information broadly and the other party's narrowly. Or that give one party stronger remedies. Or that carve out the bigger company's internal information from the definition entirely.\n\nThe giveaway is usually language like \"notwithstanding the foregoing\" buried in Section 3. That's where the asymmetry hides. If you're the smaller party, read carefully for any clause that treats you differently.",
      },
      {
        heading: "How to Convert One-way to Mutual",
        body: 'It\'s actually simple. Replace "Disclosing Party" and "Receiving Party" with "Each Party" throughout the document. Change the singular obligations to apply to both sides. The structure of the NDA stays the same — you\'re just making it reciprocal.\n\nMost lawyers will agree to this if your contribution actually warrants it. If they resist, ask why. If they can\'t articulate a reason that doesn\'t boil down to "we want to use your information without restriction," that\'s useful to know.',
      },
    ],
    faq: [
      {
        q: "What if they won't budge on a one-way NDA?",
        a: "Decide whether you're sharing anything worth protecting. If you're just receiving information, sign it and move on. If you're sharing your pitch deck or source code, walk.",
      },
    ],
  },
  {
    slug: "nda-non-solicit-trap",
    category: "nda-red-flags",
    title: "The Non-Solicit Trap Hidden in Most NDAs",
    description:
      "A non-solicit clause buried in an NDA can stop you from hiring, partnering, or pitching — for years. Here's how to spot it.",
    excerpt:
      "Many NDAs slip a non-solicit into Section 7. It's a separate restriction with its own consequences — and you can negotiate it out.",
    keyword: "NDA non-solicit clause",
    tags: ["red-flags", "nda", "non-solicit", "scope", "negotiation"],
    readTime: "4 min",
    publishedAt: "2026-04-06",
    updatedAt: "2026-04-24",
    tldr: "A friend of mine signed an NDA for what was supposed to be a casual partnership conversation between his startup and a much larger company. The conversation went nowhere. The companies never worked together. He forgot about the NDA entirely.\n\nTwo years later, he hired a developer who used to work at that larger company. Within a week, he got a letter from their legal department citing the NDA. Not for confidentiality — he hadn't shared any secrets. For the non-solicit clause buried on page four.\n\nHe'd never even noticed it was there. And technically, he was in violation.",
    sections: [
      {
        heading: "What a Non-solicit Looks Like Inside an NDA",
        body: "The language varies, but it usually goes something like:\n\n\"Receiving Party shall not, for a period of two years following the disclosure of Confidential Information, directly or indirectly solicit, hire, or engage any employee, contractor, or customer of the Disclosing Party.\"\n\nRead that again. This is not about confidentiality. This has nothing to do with protecting secrets. It's a hiring restriction — a lightweight non-compete — that limits who you can work with, entirely separate from anything you learned during the engagement.\n\nThe problem is that it's bundled into a document you think is just about secrecy. You're scanning for \"don't share our trade secrets\" and your eyes glaze over the part about not hiring anyone. But the obligations are separate, and a breach of the non-solicit is just as actionable as a breach of confidentiality.",
      },
      {
        heading: "Why It's a Problem",
        body: "Confidentiality obligations are about information. Don't share what you learned, don't use it for your own benefit, don't publish it. That makes sense in the context of an NDA.\n\nNon-solicits are about people and business relationships. They limit who you can hire, who you can work with, who you can sell to. Those are competitive restrictions — the kind of thing that should be in a separate agreement, negotiated explicitly, and compensated if they're significant.\n\nBundling them lets the other side claim a \"confidentiality breach\" when someone you hired happens to have worked for them three years ago. The real complaint isn't about secrets. It's about competition. But the NDA gives them a legal hook because the non-solicit was in the same document.",
      },
      {
        heading: "How to Negotiate It Out",
        body: "Option one: delete it entirely. This is the cleanest approach and the easiest to defend. \"This is a confidentiality agreement. The non-solicit is about competition, not secrecy. Let's address that separately if needed.\"\n\nOption two: narrow the scope. If they insist on keeping it, limit it to people you actually met or worked with during the engagement — not the entire employee base of a company with thousands of people. And shorten the duration: 6 months is reasonable, 12 months is aggressive, anything longer is excessive for a non-solicit that arose from a casual NDA.\n\nOption three: make it mutual. If you're restricted from hiring their people, they should be restricted from hiring yours. Fairness often gets these clauses softened or removed entirely.",
      },
      {
        heading: "Are Non-solicits Even Enforceable?",
        body: "Sometimes. It depends on your state, the scope, and whether the relationship justifies the restriction. California tends not to enforce them. New York often does. Most other states are somewhere in between.\n\nBut enforceability is the wrong question. The right question is: do you want to receive a threatening letter from a lawyer two years from now over a clause you never knew was in the document? Even if you'd ultimately win in court, the cost of getting there is the punishment. The clause works by making you afraid to fight it.",
      },
    ],
    faq: [
      {
        q: "What if I already signed one?",
        a: "Don't panic. Non-solicits are among the most frequently challenged restrictions because they're often overbroad. If you're in a situation where one might apply, consult an employment attorney before taking any action. A quick review is cheaper than litigation.",
      },
    ],
  },

  // ---------- NDA EXPLAINED ----------
  {
    slug: "nda-explained-section-by-section",
    category: "nda-explained",
    title: "NDA Explained: Every Section in Plain English",
    description:
      "Walk through every section of a standard non-disclosure agreement — definitions, term, exclusions, remedies, and signatures.",
    excerpt:
      "A standard NDA has 8 sections. Here's exactly what each one does and where companies sneak in extra restrictions.",
    keyword: "NDA explained",
    tags: ["explained", "nda", "scope", "term", "remedies"],
    readTime: "2 min",
    publishedAt: "2026-04-02",
    updatedAt: "2026-04-22",
    tldr: "An NDA looks intimidating but it's really just eight sections, and six of them are basically standard. Once you've read a few, you can review one in about three minutes and know exactly where the problems are.",
    sections: [
      {
        heading: "Parties",
        body: 'Who\'s involved. The disclosing party (sharing secrets) and the receiving party (keeping them). In a mutual NDA, both wear both hats. Watch for "affiliates" — some NDAs extend obligations to hundreds of unnamed subsidiary companies. Ask for a list.',
      },
      {
        heading: "Definition of Confidential Information",
        body: 'The most important section. A fair NDA limits coverage to information marked confidential or that a reasonable person would treat as such. "All information, regardless of form" is a trap — it covers everything and protects nothing, because it\'s too vague to enforce consistently.',
      },
      {
        heading: "Permitted Use and Recipients",
        body: "What you can do with the info and who else can see it. Usually limited to evaluating the stated business purpose, shared only with employees who need to know and are under similar confidentiality duties.",
      },
      {
        heading: "Exclusions",
        body: "The four standard carve-outs: public information, prior knowledge, independent development, and third-party disclosure. If any are missing, someone removed them deliberately. All four missing means you're signing a trap.",
      },
      {
        heading: "Term and Survival",
        body: 'How long the obligations last. 2-5 years is normal. Trade secrets can survive indefinitely but should be identified as such. A blanket "all info survives 10 years" is unusual and aggressive.',
      },
      {
        heading: "Return or Destruction",
        body: "What happens when the relationship ends. Usually return or destroy within 30 days, keep one copy for compliance. Watch for unreasonable demands like certifying under penalty of perjury.",
      },
      {
        heading: "Remedies",
        body: "Injunctive relief (court order) plus money damages is standard. Watch for one-sided attorney fee shifting or liquidated damages.",
      },
      {
        heading: "Boilerplate",
        body: "Choice of law, venue, severability. The choice-of-law line matters: if you're in Texas and the NDA says New York law governs, disputes just got more expensive. Push for your home state.",
      },
    ],
    faq: [
      {
        q: "Can verbal info be confidential?",
        a: "Yes, if the NDA says so — usually with a requirement to confirm in writing within a few days.",
      },
      {
        q: "What if I breach accidentally?",
        a: "Still a breach. NDAs are generally strict liability. Narrow definitions are your best protection.",
      },
    ],
  },
  {
    slug: "what-counts-as-confidential-information",
    category: "nda-explained",
    title: "What Counts as 'Confidential Information' in an NDA?",
    description:
      "What 'confidential information' actually means under a standard NDA — and the four categories courts won't protect.",
    excerpt:
      "The phrase 'confidential information' isn't self-defining. Here's how courts decide what's actually covered.",
    keyword: "confidential information NDA",
    tags: ["explained", "nda", "scope", "definitions"],
    readTime: "2 min",
    publishedAt: "2026-04-05",
    updatedAt: "2026-04-23",
    tldr: "The phrase sounds precise. It's not. It means whatever the NDA says it means.",
    sections: [
      {
        heading: "The Contract Defines the Scope",
        body: "Unlike trade secret law with its statutory tests, an NDA's scope is purely contractual. Sign something saying \"all information\" is confidential and you've agreed to treat everything as confidential. Courts might narrow unreasonably broad definitions, but they might not, and you don't want to be the test case.",
      },
      {
        heading: "The Four Standard Exclusions",
        body: "(1) Public information already out there. (2) Prior knowledge you had before signing. (3) Independent development without using the disclosed info. (4) Third-party disclosure from someone with no confidentiality duties. Missing exclusions are deliberate, not accidental.",
      },
      {
        heading: "Marking Requirements",
        body: "Some NDAs say info only counts as confidential if marked. Great for receiving parties — you know exactly what's covered. Risky for disclosing parties who forget to label documents.",
      },
      {
        heading: "Residual Knowledge",
        body: "Some NDAs let you use general ideas retained in unaided memory. Controversial because it's hard to prove what came from memory vs specific documents. Worth including in creative or technical fields.",
      },
    ],
    faq: [
      {
        q: "Is metadata (who I met with) confidential?",
        a: "Only if the NDA specifically says so. Some include non-disclosure-of-relationship clauses separately.",
      },
    ],
  },

  // ---------- NDA TEMPLATES ----------
  {
    slug: "mutual-nda-template",
    category: "nda-templates",
    title: "Free Mutual NDA Template (Plain-English)",
    description:
      "A balanced mutual NDA template — short, fair, and ready to adapt for partnerships, pitches, and joint development.",
    excerpt:
      "Two pages, no jargon, balanced for both sides. Use it when you and the other party are both sharing real information.",
    keyword: "mutual NDA template",
    tags: ["template", "nda", "mutual-nda", "term"],
    readTime: "2 min",
    publishedAt: "2026-04-08",
    updatedAt: "2026-04-25",
    tldr: "I've sent this to partners, collaborators, agencies, and investors. Most signed without changes. Nobody refused it — it protects both sides equally.",
    sections: [
      {
        heading: "What's Inside",
        body: "Narrow definitions of confidential information with all four standard exclusions. Mutual obligations applied equally. Three-year term (customizable to 1-5). Clean return-or-destroy clause. Injunctive relief as primary remedy. No liquidated damages, no one-way fee shifting.",
      },
      {
        heading: "What to Customize",
        body: "Term length (3 years default, 5 for long product development, 1 for exploratory talks). Governing state (use yours, or Delaware as neutral). Non-solicit inclusion (my default is no — negotiate separately if needed).",
      },
      {
        heading: "When to Use",
        body: "Pitch meetings, joint development discussions, acquisition talks. Any situation where both sides share real information.",
      },
    ],
    faq: [
      {
        q: "Can I just email this instead of DocuSign?",
        a: 'A reply saying "agreed" is legally binding in most cases, but get a proper signature for anything significant.',
      },
    ],
  },
  {
    slug: "one-way-nda-template",
    category: "nda-templates",
    title: "Free One-Way NDA Template (For Disclosers)",
    description:
      "A simple one-way NDA template for when only one side is disclosing — interviews, vendor diligence, or beta access.",
    excerpt:
      "When only you're disclosing — beta testers, contractors, candidates — a one-way NDA does the job in a single page.",
    keyword: "one way NDA template",
    tags: ["template", "nda", "term", "remedies"],
    readTime: "2 min",
    publishedAt: "2026-04-09",
    updatedAt: "2026-04-25",
    tldr: "Sometimes only one side is sharing. Interviewing a candidate. Onboarding a contractor. Letting a beta tester see your product. A one-way NDA is the right tool.",
    sections: [
      {
        heading: "Best Use Cases",
        body: "Interviews where you want to discuss real plans, not vague hypotheticals. Contractor onboarding before giving access to codebases or customer lists. Vendor evaluations where they need to understand your stack. Beta access for unreleased features.",
      },
      {
        heading: "Keep It Simple",
        body: 'Avoid the temptation to add every protection. No liquidated damages. No arbitration in your home state. No non-solicit. A short, fair NDA gets signed immediately. A long, aggressive one sits in an inbox for three days while they "think about it."',
      },
      {
        heading: "Send It Before the Conversation",
        body: "Information disclosed before signing isn't covered. Send the NDA the day before and get confirmation before you start talking.",
      },
    ],
    faq: [
      {
        q: "What if they want changes?",
        a: "If reasonable — adjusting term, narrowing definition — accommodate them. The goal is protection, not domination.",
      },
    ],
  },

  // ---------- FREELANCE RED FLAGS ----------
  {
    slug: "freelance-contract-red-flags",
    category: "freelance-red-flags",
    title: "12 Freelance Contract Red Flags That Cost You Money",
    description:
      "From unpaid IP transfers to indefinite revisions and net-90 payment, the freelance contract clauses you must refuse.",
    excerpt:
      "Most freelance disputes are predictable from the contract. These 12 clauses are the ones to negotiate or walk away from.",
    keyword: "freelance contract red flags",
    tags: ["red-flags", "freelance", "ip", "scope", "payment", "kill-fee", "negotiation"],
    readTime: "3 min",
    publishedAt: "2026-04-10",
    updatedAt: "2026-04-26",
    tldr: "I've freelanced for about a decade. Most bad client situations were predictable from the contract — not the vibe on the call, not the promises in the email, the actual language in the agreement.",
    sections: [
      {
        heading: "1. IP Transfer Before Payment",
        body: "Some contracts transfer ownership the moment you create the work, before a single invoice is paid. Your IP clause should say ownership transfers only upon full payment. That single sentence has saved me more than anything else.",
      },
      {
        heading: "2. Unlimited Revisions",
        body: 'I had a client go through 17 rounds of "minor tweaks" on a logo. Two rounds per deliverable is standard. After that, it\'s a change order at your hourly rate.',
      },
      {
        heading: "3. Net-60 or Net-90 Payment",
        body: "Common in enterprise, devastating for freelancers. Sixty days is two rent payments. Push for net-15 or net-30 with late fees. If they insist on longer terms, demand 50% up front.",
      },
      {
        heading: "4. No Kill Fee",
        body: "If they cancel mid-project, you should get paid for completed work plus 25-50% of remaining scope. Without it, they can cancel on day 29 of a 30-day project while you turned down other work.",
      },
      {
        heading: "5. Indemnification with No Cap",
        body: "You should never indemnify a client for more than the total fees they paid you. Uncapped means you're potentially on the hook for millions over a $5,000 project.",
      },
      {
        heading: "6. Termination for Convenience Without Pay",
        body: "If they can terminate anytime for any reason, they should still pay for work in progress, not just completed deliverables.",
      },
      {
        heading: "7. Overbroad Non-compete",
        body: "You're a freelancer, not an employee. A two-year industry-wide non-compete is absurd and probably unenforceable, but it can still scare future clients. Strike or narrow it.",
      },
      {
        heading: "8. Work Made for Hire on Non-qualifying Work",
        body: "Copyright law restricts work-for-hire to specific categories. Outside those, a separate IP assignment is needed — and it should fire only on payment.",
      },
      {
        heading: "9. Mandatory Arbitration in a Faraway State",
        body: "If you're in Texas and the contract requires arbitration in New York under New York law, your only recourse is prohibitively expensive.",
      },
      {
        heading: "10. Vague Deliverables",
        body: '"A website" without page counts, feature lists, or design rounds is not scope. It\'s an invitation to endless work.',
      },
    ],
    faq: [
      {
        q: "What if the client refuses to negotiate?",
        a: "Walk. A client who treats freelancers as adversaries during contracting will treat you the same during the project.",
      },
    ],
  },
  {
    slug: "freelance-payment-red-flags",
    category: "freelance-red-flags",
    title: "Freelance Payment Red Flags: Getting Paid On Time",
    description:
      "Net-60 terms, payment-on-acceptance language, and undefined approval — the payment clauses that delay your invoices indefinitely.",
    excerpt:
      "The single biggest predictor of late payment is the payment clause itself. Here's what to spot.",
    keyword: "freelance payment terms red flags",
    tags: ["red-flags", "freelance", "payment", "kill-fee"],
    readTime: "2 min",
    publishedAt: "2026-04-12",
    updatedAt: "2026-04-26",
    tldr: "The single biggest predictor of whether you'll get paid on time is the payment clause itself.",
    sections: [
      {
        heading: "Payment on Acceptance Traps",
        body: 'Some contracts say you get paid only after the client "accepts" the work, with no deadline for acceptance defined. The client can delay by never saying they\'re satisfied. I add: "Deliverables are deemed accepted unless rejected in writing with specific reasons within 5 business days."',
      },
      {
        heading: "Net-60 and Net-90 Terms",
        body: "Standard for enterprises but a cash-flow nightmare. I counter with net-30 plus 1.5% monthly late fee, or split the invoice: 50% net-15, 50% net-45.",
      },
      {
        heading: "No Deposit",
        body: "A client who won't pay a deposit won't pay on time. Period. I've tested this over years and the correlation is nearly perfect. I ask 50% up front on new relationships, 25% on ongoing. Refusers almost always become payment problems.",
      },
    ],
    faq: [
      {
        q: "Are late fees enforceable?",
        a: "Yes, when reasonable — typically 1-2% per month. Courts disfavor punitive rates.",
      },
    ],
  },
  {
    slug: "freelance-ip-clause-red-flags",
    category: "freelance-red-flags",
    title: "Freelance IP Clause Red Flags: Don't Give Away Your Work for Free",
    description:
      "Work-for-hire, IP assignment, moral rights waivers — the freelance IP clauses to read line by line.",
    excerpt:
      "An IP clause that fires before payment means the client owns your work even if your invoice goes unpaid. Here's how to fix it.",
    keyword: "freelance IP clause",
    tags: ["red-flags", "freelance", "ip", "negotiation"],
    readTime: "2 min",
    publishedAt: "2026-04-14",
    updatedAt: "2026-04-27",
    tldr: "The IP clause is where most freelance relationships either work or blow up. The issue is always the same: who owns what, and when does ownership transfer.",
    sections: [
      {
        heading: "Tie IP Transfer to Payment",
        body: 'Your contract should say: "All right, title, and interest in deliverables shall transfer to Client upon receipt of full payment for the corresponding milestone." Without it, the client can own your work while your invoice sits unpaid. I learned this freelancing for a startup that ran out of money mid-project — my work was live on their site, my invoice was 60 days overdue, my contract said IP transferred "upon creation." Zero leverage.',
      },
      {
        heading: "Reserve a Portfolio License",
        body: 'Add: "Contractor retains a non-exclusive right to display deliverables in portfolios and case studies." Most clients are fine with this. Some push back on confidentiality grounds — negotiate, but it\'s worth asking.',
      },
      {
        heading: "Beware Pre-existing IP Grabs",
        body: 'Some contracts claim all IP you\'ve "ever created or will create." Limit assignment to deliverables produced under this specific engagement.',
      },
    ],
    faq: [
      {
        q: "What if the client wants exclusive rights?",
        a: "Exclusive doesn't mean work-for-hire. You can grant an exclusive license while retaining ownership, preserving portfolio rights.",
      },
    ],
  },

  // ---------- FREELANCE EXPLAINED ----------
  {
    slug: "freelance-contract-explained",
    category: "freelance-explained",
    title: "Freelance Contracts Explained: Section by Section",
    description:
      "What every section of a freelance contract actually does — scope, payment, IP, termination, and indemnification.",
    excerpt:
      "A freelance contract is just 9 sections. Master them and you'll never sign a bad gig again.",
    keyword: "freelance contract explained",
    tags: ["explained", "freelance", "scope", "payment", "ip", "termination"],
    readTime: "2 min",
    publishedAt: "2026-04-11",
    updatedAt: "2026-04-26",
    tldr: "A freelance contract has nine sections. Master them and you'll never sign a bad gig again.",
    sections: [
      {
        heading: "Parties",
        body: "You as contractor (not employee). If working through an LLC, sign in the LLC's name for liability protection.",
      },
      {
        heading: "Scope of Work",
        body: 'The single most important section. "Build a website" isn\'t scope. "Build a 5-page responsive website with contact form, assuming client provides all copy and images" is scope.',
      },
      {
        heading: "Deliverables and Acceptance",
        body: 'Each deliverable needs a clear acceptance criterion and a deadline for client feedback. Without "deemed accepted after X days," you\'ll chase sign-off forever.',
      },
      {
        heading: "Payment Terms",
        body: "Deposit (25-50%), milestone schedule, net-15 or net-30 invoicing, late fees, expense reimbursement. Always get a deposit.",
      },
      {
        heading: "IP and Licenses",
        body: "Ownership transfers on payment. Reserve portfolio rights. Specify any third-party assets you're licensing and passing through.",
      },
      {
        heading: "Confidentiality",
        body: "Mutual is ideal. At minimum, carve out your general know-how so you can do similar work for other clients.",
      },
      {
        heading: "Termination",
        body: "For cause (uncured material breach) and for convenience (with notice and kill fee). Both require payment for work completed.",
      },
      {
        heading: "Indemnification",
        body: "Both sides indemnify for their own IP and conduct. Cap total liability at fees paid — never uncapped.",
      },
      {
        heading: "Boilerplate",
        body: "Choice of law, independent contractor status. The governing state matters if you ever need to enforce.",
      },
    ],
    faq: [
      {
        q: "Do I need a separate SOW?",
        a: "Yes — negotiate legal terms once in an MSA, then a short SOW per project.",
      },
    ],
  },
  {
    slug: "scope-creep-explained",
    category: "freelance-explained",
    title: "Scope Creep Explained (and How Your Contract Should Handle It)",
    description:
      "What scope creep actually is, why it happens, and the contract clauses that contain it before it eats your margin.",
    excerpt:
      "Scope creep doesn't usually look like a 'change.' It looks like a 'small tweak.' Here's how a tight contract stops it.",
    keyword: "scope creep contract",
    tags: ["explained", "freelance", "scope", "negotiation"],
    readTime: "2 min",
    publishedAt: "2026-04-13",
    updatedAt: "2026-04-26",
    tldr: 'Scope creep doesn\'t announce itself. It comes as a Slack message: "Quick thing — can we add a contact form to that page?" or "One small tweak — logo a bit bigger?" Individually nothing. Collectively, the reason freelancers work twice the hours they bill.',
    sections: [
      {
        heading: "What It Is",
        body: "Anything outside the original deliverable list. Doesn't matter how small or how politely asked. If it wasn't in scope, it's additional work.",
      },
      {
        heading: "The Change Order Clause",
        body: "My contracts say: \"Any work beyond the scope is treated as a Change requiring a written Change Order signed by both parties before work begins. Changes are billed at $X/hour or as a fixed fee.\" This isn't hostile. It's clarifying.",
      },
      {
        heading: "Revision Caps",
        body: 'Two rounds per deliverable is standard. Define "a round" explicitly: one consolidated set of feedback received within X business days.',
      },
    ],
    faq: [
      {
        q: "What if they refuse to sign change orders?",
        a: "Stop work until they do. The contract should explicitly allow this.",
      },
    ],
  },

  // ---------- FREELANCE TEMPLATES ----------
  {
    slug: "freelance-contract-template",
    category: "freelance-templates",
    title: "Free Freelance Contract Template (Designer/Developer/Writer)",
    description:
      "A balanced freelance contract template with clear scope, payment, IP, and termination — adapt for design, dev, or writing work.",
    excerpt:
      "A 4-page contract that protects your IP, your payment, and your margin. Use it as your master template.",
    keyword: "freelance contract template",
    tags: ["template", "freelance", "scope", "payment", "ip", "kill-fee"],
    readTime: "2 min",
    publishedAt: "2026-04-15",
    updatedAt: "2026-04-27",
    tldr: "This is the contract I use for design, development, and writing work. Four pages, clean language, protects both sides. 50% deposit, net-15 invoicing, IP transfers on payment, two revision rounds, 14-day termination for convenience with full work-in-progress payment, change orders at your rate, portfolio rights reserved.",
    sections: [
      {
        heading: "Customize",
        body: "Update your rate, deposit percentage, payment terms, and governing state. Everything else is field-tested. For international clients, specify currency (I use USD with fixed exchange rate at signing) and add ICC arbitration clause.",
      },
    ],
    faq: [
      {
        q: "Does this handle scope creep?",
        a: "Yes — the change order clause requires signed approval for anything outside original scope, billed separately.",
      },
    ],
  },
  {
    slug: "freelance-sow-template",
    category: "freelance-templates",
    title: "Free Statement of Work (SOW) Template for Freelancers",
    description:
      "A simple SOW template that pairs with your master agreement — deliverables, dates, dollars, and assumptions.",
    excerpt:
      "Stop renegotiating legal terms every project. Use a master agreement once, then a 1-page SOW per engagement.",
    keyword: "freelance SOW template",
    tags: ["template", "freelance", "scope", "payment"],
    readTime: "2 min",
    publishedAt: "2026-04-16",
    updatedAt: "2026-04-27",
    tldr: "Stop renegotiating legal terms for every project. Use a Master Service Agreement once, then a one-page Statement of Work per engagement.\n\nA clean SOW has five fields: deliverables (specific, measurable, dated), milestones (what gets delivered when), fees (total and per-milestone), assumptions (what you assume the client provides — assets, access, sign-off windows), and signatures.",
    sections: [
      {
        heading: "The Assumptions Field",
        body: 'The section most freelancers skip and where scope creep comes from. "Client provides all copy within 5 business days." "Client provides brand assets in vector format." "Client responds to feedback within 3 business days." If they don\'t meet these, your deadlines shift. Write it down.',
      },
    ],
    faq: [
      {
        q: "Does it need to be signed?",
        a: "Yes. Even a one-line email works, but a signed SOW is stronger if you ever need to enforce.",
      },
    ],
  },

  // ---------- EMPLOYMENT RED FLAGS ----------
  {
    slug: "employment-offer-red-flags",
    category: "employment-red-flags",
    title: "10 Employment Offer Red Flags to Negotiate Before Signing",
    description:
      "From at-will fine print to signing bonus clawbacks, IP assignments, and non-competes — the offer letter clauses that hurt you most.",
    excerpt:
      "An offer letter is a contract. These 10 clauses are the ones to push back on before you sign.",
    keyword: "employment offer red flags",
    tags: ["red-flags", "employment", "non-compete", "ip", "clawback", "vesting", "negotiation"],
    readTime: "2 min",
    publishedAt: "2026-04-17",
    updatedAt: "2026-04-27",
    tldr: "An offer letter feels like a celebration. That's exactly when people sign things they shouldn't.",
    sections: [
      {
        heading: "Signing Bonus Clawback Over 12 Months",
        body: "If you leave within the clawback period, you pay back the bonus. 12 months pro-rated is reasonable. 24 months is a trap. Under $20K, try to eliminate the clawback entirely.",
      },
      {
        heading: "Broad IP Assignment",
        body: "Some offers claim everything you create during employment, even on your own time and equipment, unrelated to the business. Several states (California, Washington, Illinois) limit this. Get a carve-out for personal projects.",
      },
      {
        heading: "Non-compete Hidden in Handbook",
        body: "The offer references the Employee Handbook. Ask for it before signing. Non-competes and arbitration clauses often hide in documents you've never seen.",
      },
      {
        heading: "Mandatory Arbitration with Class Waiver",
        body: "You lose the right to sue and join class actions. Some companies allow opt-out within 30 days of starting — ask.",
      },
      {
        heading: "Discretionary Bonus with No Formula",
        body: 'If the offer says "eligible for a target bonus of 15%" with no formula, treat that number as zero in your budget. I\'ve seen "discretionary" bonuses range from 120% of target to literally nothing.',
      },
      {
        heading: "Equity Without Acceleration",
        body: 'If acquired and terminated, unvested equity disappears. Single or double-trigger acceleration protects you. Standard ask — many companies grant it.\n\nPTO "USE IT OR LOSE IT" IN NON-PERMITTING STATES — Some states (California, Colorado) require PTO payout. Confirm the policy matches your state\'s law.',
      },
    ],
    faq: [
      {
        q: "Should I get a lawyer?",
        a: "For senior roles, equity-heavy comp, or non-competes — yes. One hour costs $300-500 and almost always pays for itself.",
      },
    ],
  },
  {
    slug: "at-will-employment-red-flags",
    category: "employment-red-flags",
    title: "At-Will Employment Red Flags: When 'Standard' Language Isn't Standard",
    description:
      "What at-will employment actually means, and the offer-letter language that strips your protections beyond the default.",
    excerpt:
      "At-will doesn't mean lawless. Some offer letters add language that quietly waives the protections you do have.",
    keyword: "at will employment red flags",
    tags: ["red-flags", "employment", "at-will", "termination"],
    readTime: "2 min",
    publishedAt: "2026-04-18",
    updatedAt: "2026-04-27",
    tldr: "At-will means either side can end the relationship anytime, for any non-discriminatory reason, with no notice. Default in every state except Montana.",
    sections: [
      {
        heading: "Language That Goes Further",
        body: "Some offers add: \"Employee waives any reliance on prior representations of job security.\" This isn't restating at-will status. This tries to defeat misrepresentation claims — if a recruiter promised stability and you're laid off three months later, this clause blocks your claim.",
      },
      {
        heading: "Carve-outs You Can't Waive",
        body: "Statutory rights (anti-discrimination, FMLA, whistleblower) cannot be waived. If the offer suggests otherwise, it's either legally ignorant or deliberately intimidating. Doesn't actually strip those rights but might discourage you from asserting them.",
      },
      {
        heading: "Probationary Period",
        body: "If they can fire you without notice during probation, you should be able to quit without notice too. Asymmetry is a red flag.",
      },
    ],
    faq: [
      {
        q: "Can I get severance even at-will?",
        a: "Only if the contract or company policy provides it. Negotiate up front.",
      },
    ],
  },

  // ---------- EMPLOYMENT EXPLAINED ----------
  {
    slug: "offer-letter-explained",
    category: "employment-explained",
    title: "Offer Letter Explained: Every Section in Plain English",
    description:
      "What every section of a standard employment offer letter actually does — title, comp, equity, benefits, and the fine print.",
    excerpt:
      "An offer letter looks simple. The 7 sections inside it determine your next 5 years. Here's what each one means.",
    keyword: "offer letter explained",
    tags: ["explained", "employment", "vesting", "ip", "non-compete"],
    readTime: "2 min",
    publishedAt: "2026-04-19",
    updatedAt: "2026-04-27",
    tldr: "Seven sections. Each matters more than it looks.",
    sections: [
      {
        heading: "Role and Title",
        body: 'Your title follows you to your next job. Confirm reporting line, location, and remote-work expectations in writing. "Hybrid" means different things to different companies.',
      },
      {
        heading: "Compensation",
        body: 'Base salary, bonus structure, guaranteed first-year amounts. Get the bonus formula. "Target of 15% based on company and individual performance" without a formula means they can pay anything from 0% to 15%.',
      },
      {
        heading: "Equity",
        body: "Shares, vesting schedule (usually 4 years with 1-year cliff), strike price, acceleration on change of control. Ask for total outstanding shares so you know what percentage your grant represents.",
      },
      {
        heading: "Benefits",
        body: 'Health, dental, 401(k) match, PTO, parental leave. Ask for the actual benefits summary, not bullet points. "Competitive health benefits" could mean a $6,000 deductible.',
      },
      {
        heading: "Restrictive Covenants",
        body: "Confidentiality, IP assignment, non-compete, non-solicit. Most negotiable and most consequential section.",
      },
    ],
    faq: [
      {
        q: "Should I sign on the spot?",
        a: "No. A reasonable employer gives 48-72 hours. Pressure to sign immediately is itself a red flag.",
      },
    ],
  },
  {
    slug: "equity-vesting-explained",
    category: "employment-explained",
    title: "Equity Vesting Explained: Cliffs, Schedules, and Acceleration",
    description:
      "How equity vesting actually works — cliffs, monthly vesting, acceleration, and what happens if you leave.",
    excerpt:
      "Vesting determines what you actually own. Here's how to read your vesting schedule and what to negotiate.",
    keyword: "equity vesting explained",
    tags: ["explained", "employment", "vesting", "equity"],
    readTime: "2 min",
    publishedAt: "2026-04-20",
    updatedAt: "2026-04-27",
    tldr: "Equity is the part of your compensation that's supposed to make you rich if the company succeeds. It's also the part easiest to misunderstand and easiest to lose.",
    sections: [
      {
        heading: "Cliff Vesting",
        body: "Standard: 4-year vest with 1-year cliff. You get zero equity until you've been there 12 months. At your one-year anniversary, 25% vests. After that, the remaining 75% vests monthly or quarterly over three years. Leave before the cliff and you walk with nothing.",
      },
      {
        heading: "Acceleration Triggers",
        body: "Single-trigger: equity vests on acquisition. Rare but valuable. Double-trigger: vests only if acquired AND you're terminated without cause within 12-18 months. More common at later-stage companies. Neither means an acquisition could wipe out unvested equity.",
      },
      {
        heading: "Exercise Windows",
        body: "When you leave, you typically have 90 days to exercise vested options by paying the strike price out of pocket. Can't afford it? You forfeit them. Some companies offer 5-10 year extended windows — worth asking for.",
      },
      {
        heading: "ISO vs NSO",
        body: "ISOs can qualify for capital gains treatment if held long enough. NSOs taxed as ordinary income on exercise. The difference can be tens of thousands. Talk to a CPA before exercising significant amounts.",
      },
    ],
    faq: [
      {
        q: "What if the company never goes public?",
        a: "Your equity might be worth zero. Treat startup equity as a lottery ticket, not a retirement plan.",
      },
    ],
  },

  // ---------- NON-COMPETE RED FLAGS ----------
  {
    slug: "non-compete-red-flags",
    category: "non-compete-red-flags",
    title: "Non-Compete Red Flags That Could Sideline Your Career",
    description:
      "Worldwide scope, multi-year duration, broad industry definitions — the non-compete clauses that go beyond enforceable.",
    excerpt:
      "A non-compete that looks reasonable on page one can become unenforceable on page two. Here are the worst offenders.",
    keyword: "non-compete red flags",
    tags: ["red-flags", "non-compete", "scope", "term", "negotiation"],
    readTime: "2 min",
    publishedAt: "2026-04-21",
    updatedAt: "2026-04-27",
    tldr: "A fair non-compete has three reasonable limits. A predatory one has none.",
    sections: [
      {
        heading: "Worldwide Geography",
        body: "Unless you're a global executive, worldwide scope is absurd and usually unenforceable. Negotiate to your actual operating region.\n\n2+ YEAR DURATION — 12 months is the ceiling for non-executive roles. Longer requires strong justification and garden leave compensation.",
      },
      {
        heading: "Industry-wide Definition of Competitor",
        body: '"Any company in the technology sector" means you can\'t work anywhere. Narrow to companies with specific product overlap.',
      },
      {
        heading: "No Garden Leave",
        body: "Some states require employers to pay during the restricted period. Even where not required, it's a negotiating point: if they restrict your ability to work, they should pay for that time.",
      },
      {
        heading: "Triggered on Any Termination",
        body: "Fair non-competes don't fire when the employer terminates you without cause. Only on resignation or termination for cause.",
      },
    ],
    faq: [
      {
        q: "Are non-competes enforceable in California?",
        a: "Almost never. California voids them by statute with very limited exceptions.",
      },
    ],
  },
  {
    slug: "garden-leave-red-flags",
    category: "non-compete-red-flags",
    title: "Garden Leave Red Flags: Paid Time Off That Isn't Really Off",
    description:
      "Garden leave can be a generous transition or a soft non-compete. Here's how to tell the difference before you sign.",
    excerpt:
      "Garden leave looks like extra severance. Sometimes it is. Sometimes it's a non-compete the company can extend at will.",
    keyword: "garden leave clause",
    tags: ["red-flags", "non-compete", "garden-leave", "term"],
    readTime: "2 min",
    publishedAt: "2026-04-22",
    updatedAt: "2026-04-28",
    tldr: "Garden leave sounds generous — the company pays you to not work after you leave. Sometimes it is. Sometimes it's a non-compete dressed up in severance clothing.",
    sections: [
      {
        heading: "Good Garden Leave",
        body: "30-90 days, full pay and benefits, defined end date, your only restriction. When it ends, you're free.",
      },
      {
        heading: "Bad Garden Leave",
        body: "Employer extends unilaterally. Pay drops to base only — no bonus, no equity vesting. Or it stacks on top of a separate non-compete period, so you're restricted for garden leave plus another 12 months. That's extended restraint without compensation.",
      },
    ],
    faq: [
      {
        q: "Can I take a non-competing job during garden leave?",
        a: "Usually yes if the contract doesn't restrict outside work. Always confirm in writing.",
      },
    ],
  },

  // ---------- NON-COMPETE EXPLAINED ----------
  {
    slug: "non-compete-explained",
    category: "non-compete-explained",
    title: "Non-Compete Agreements Explained (and When They're Enforceable)",
    description:
      "How non-competes work, the three reasonableness factors courts apply, and which states won't enforce them at all.",
    excerpt:
      "A non-compete is enforceable only when it's reasonable in time, geography, and scope. Here's exactly how courts decide.",
    keyword: "non-compete agreement explained",
    tags: ["explained", "non-compete", "scope", "term"],
    readTime: "2 min",
    publishedAt: "2026-04-23",
    updatedAt: "2026-04-28",
    tldr: "Courts test five things: protectable interest (trade secrets, customer relationships, specialized training), reasonable time (6-12 months for most roles), reasonable geography (where the employer actually operates), reasonable scope (direct competitors only), and consideration (you received something in exchange).",
    sections: [
      {
        heading: "States That Won't Enforce",
        body: "California, North Dakota, Oklahoma, and Minnesota largely refuse. Washington and Massachusetts require minimum salary thresholds. The FTC's 2024 ban is currently tied up in court — treat enforceability as state-by-state.",
      },
      {
        heading: "Blue-pencil vs All-or-nothing",
        body: "Some states narrow overbroad non-competes to enforceable scope. Others void the entire clause if any part is unreasonable. Know which rule applies in your state.",
      },
    ],
    faq: [
      {
        q: "Can I be sued for taking a new job?",
        a: "Yes. The new employer might also be sued. Most companies don't pursue it, but the risk is real for senior roles.",
      },
    ],
  },

  // ---------- SEVERANCE RED FLAGS ----------
  {
    slug: "severance-red-flags",
    category: "severance-red-flags",
    title: "Severance Agreement Red Flags You Should Negotiate",
    description:
      "Hidden releases, broad non-disparagement, short signing windows, and clawbacks — the severance clauses to push back on.",
    excerpt:
      "A severance offer is the company's first offer, not their last. These clauses are usually negotiable.",
    keyword: "severance agreement red flags",
    tags: ["red-flags", "severance", "release", "non-disparagement", "negotiation"],
    readTime: "2 min",
    publishedAt: "2026-04-24",
    updatedAt: "2026-04-28",
    tldr: "A severance offer is the company's first offer, not their last. Almost everything is negotiable.",
    sections: [
      {
        heading: "Short Signing Window",
        body: "Federal law requires 21 days if you're 40+ (OWBPA) and 7 days to revoke after signing. Anything shorter is illegal. Even under 40, push for at least 14 days. Rush pressure is designed to prevent you from getting legal advice.",
      },
      {
        heading: "Broad Release with No Carve-outs",
        body: "Should exclude: unemployment benefits, vested equity, vested retirement, workers' comp, and statutory rights that can't be waived.",
      },
      {
        heading: "One-way Non-disparagement",
        body: "If you can't say anything negative but they can say whatever they want about you, push for mutuality and a neutral reference letter.",
      },
      {
        heading: "Clawback on Severance",
        body: "Some agreements forfeit severance if you violate post-employment obligations. Negotiate to limit clawback to actual damages, not the entire amount.",
      },
    ],
    faq: [
      {
        q: "Should I get a lawyer?",
        a: "For severance over a few months of pay, yes. An employment attorney charges $500-1500 and it almost always pays for itself.",
      },
    ],
  },

  // ---------- SEVERANCE EXPLAINED ----------
  {
    slug: "severance-agreement-explained",
    category: "severance-explained",
    title: "Severance Agreement Explained: What's Inside and What's Negotiable",
    description:
      "How severance agreements actually work, what you're giving up by signing the release, and what to negotiate before you do.",
    excerpt:
      "Signing severance trades your right to sue for cash. Here's how to make sure that trade is in your favor.",
    keyword: "severance agreement explained",
    tags: ["explained", "severance", "release", "negotiation"],
    readTime: "2 min",
    publishedAt: "2026-04-25",
    updatedAt: "2026-04-28",
    tldr: "Signing severance trades your right to sue for money. The question is whether you're getting enough.",
    sections: [
      {
        heading: "Payment",
        body: "1-2 weeks per year of service for non-executives, more for senior roles. Lump sum or salary continuation. Continuation extends benefits and equity vesting — often worth more than the cash difference.",
      },
      {
        heading: "Benefits",
        body: "COBRA premiums for 1-6 months are common. Confirm dental, vision, and HSA contributions are included.",
      },
      {
        heading: "Release of Claims",
        body: "You agree not to sue for anything related to employment or termination. The scope matters: employment-related only, or does it extend further?",
      },
      {
        heading: "Reference and Announcement",
        body: "Negotiate an agreed reference (or neutral: dates, title, eligible for rehire) and approval over how your departure is announced.",
      },
    ],
    faq: [
      {
        q: "Do I have to sign right away?",
        a: "No. Use the full review period. The first offer is never the final one.",
      },
    ],
  },

  // ---------- TOS RED FLAGS ----------
  {
    slug: "terms-of-service-red-flags",
    category: "tos-red-flags",
    title: "Terms of Service Red Flags Most Users Miss",
    description:
      "Class action waivers, perpetual content licenses, unilateral changes — the ToS clauses that quietly strip your rights.",
    excerpt: "Nobody reads ToS. These five clauses are why companies count on that.",
    keyword: "terms of service red flags",
    tags: ["red-flags", "tos", "arbitration", "content-license", "negotiation"],
    readTime: "2 min",
    publishedAt: "2026-04-26",
    updatedAt: "2026-04-28",
    tldr: "Nobody reads ToS. Companies know this. Here are the five clauses that quietly strip your rights.",
    sections: [
      {
        heading: "Forced Arbitration with Class Waiver",
        body: "Can't sue, can't join class actions. Some companies allow opt-out within 30 days — exercise it.",
      },
      {
        heading: "Unilateral Term Changes",
        body: '"We may update these terms at any time without notice." Continued use becomes acceptance. You can be bound by language you\'ve never seen.',
      },
      {
        heading: "Perpetual Content License",
        body: 'Anything you upload, the platform gets a "worldwide, royalty-free, perpetual, sublicensable" license. Survives account deletion. For creators, this is the clause that matters most.',
      },
      {
        heading: "Termination Without Cause or Refund",
        body: 'Even paid accounts can be terminated "at the company\'s sole discretion" with no refund.',
      },
      {
        heading: "Indemnification of the Platform",
        body: "You cover their legal costs if someone sues them over your content.",
      },
    ],
    faq: [
      {
        q: "Are these enforceable?",
        a: "Usually yes, especially arbitration clauses since AT&T v. Concepcion. Courts apply unconscionability to truly extreme terms but the bar is high.",
      },
    ],
  },

  // ---------- TOS EXPLAINED ----------
  {
    slug: "terms-of-service-explained",
    category: "tos-explained",
    title: "Terms of Service Explained for Normal Humans",
    description:
      "What ToS agreements actually do, which clauses bind you, and which ones courts often refuse to enforce.",
    excerpt:
      "ToS aren't toothless — but they're not unlimited either. Here's what's actually enforceable.",
    keyword: "terms of service explained",
    tags: ["explained", "tos", "arbitration", "content-license"],
    readTime: "2 min",
    publishedAt: "2026-04-27",
    updatedAt: "2026-04-28",
    tldr: "ToS are contracts of adhesion — take it or leave it. Courts enforce most of them, but not everything.",
    sections: [
      {
        heading: "Browsewrap vs Clickwrap",
        body: 'Clickwrap (you clicked "I agree") is broadly enforceable. Browsewrap (terms linked from footer, no acknowledgement) is much weaker — courts often refuse to enforce.',
      },
      {
        heading: "What Courts Usually Enforce",
        body: "Arbitration clauses, content licenses, liability limitations for ordinary negligence, choice of law, account termination provisions.",
      },
      {
        heading: "What Courts Often Refuse",
        body: "Total waivers of liability for gross negligence or intentional misconduct, unconscionable terms, terms hidden after a transaction.\n\nCAN TERMS CHANGE AFTER SIGN-UP? Usually yes, with notice. Continued use is deemed acceptance. Some courts now require affirmative re-acceptance for material changes.",
      },
    ],
    faq: [
      { q: "Can I negotiate a ToS?", a: "As a consumer, no. For enterprise SaaS contracts, yes." },
    ],
  },

  // ---------- PRIVACY POLICY RED FLAGS ----------
  {
    slug: "privacy-policy-red-flags",
    category: "privacy-policy-red-flags",
    title: "Privacy Policy Red Flags That Mean Your Data Is the Product",
    description:
      "Vague data sharing, indefinite retention, broad partner lists — the privacy policy patterns that signal aggressive data use.",
    excerpt:
      "A privacy policy that says 'we may share data with partners' is telling you everything. Here's how to read between the lines.",
    keyword: "privacy policy red flags",
    tags: ["red-flags", "privacy-policy", "data-sharing", "retention"],
    readTime: "2 min",
    publishedAt: "2026-04-28",
    updatedAt: "2026-04-28",
    tldr: "A privacy policy isn't just legal disclosure — it's a business model disclosure.",
    sections: [
      {
        heading: "Undefined Partners",
        body: '"We share data with partners" without naming categories or providing a list means assume the worst. GDPR requires categories at minimum. CCPA requires more.',
      },
      {
        heading: "Indefinite Retention",
        body: '"We retain data as long as necessary" tells you nothing. Strong policies specify windows tied to purposes.\n\nNO "DO NOT SELL" LINK — California residents have the right to opt out of data sales. A missing link is a CCPA violation if the company sells data. It\'s also a clear signal they monetize your information.',
      },
      {
        heading: "No Dsr Process",
        body: "GDPR and CCPA grant access, deletion, and portability rights. A policy without an exercise process is failing legal minimums in regulated jurisdictions.",
      },
    ],
    faq: [
      {
        q: 'Can I trust "we don\'t sell your data"?',
        a: 'Read the definition of "sale." Under CCPA, sharing for ad targeting can count as a sale even without money changing hands.',
      },
    ],
  },

  // ---------- PRIVACY POLICY EXPLAINED ----------
  {
    slug: "privacy-policy-explained",
    category: "privacy-policy-explained",
    title: "Privacy Policies Explained: Read One in 5 Minutes",
    description:
      "How to skim a privacy policy in 5 minutes — the sections that matter, the words to search for, and your rights under GDPR/CCPA.",
    excerpt:
      "You don't need to read every word. You need to read the 6 sections that actually affect you.",
    keyword: "privacy policy explained",
    tags: ["explained", "privacy-policy", "data-sharing", "retention"],
    readTime: "2 min",
    publishedAt: "2026-04-28",
    updatedAt: "2026-04-28",
    tldr: "You don't need to read every word. You need six pieces of information. Ctrl+F your way there.",
    sections: [
      {
        heading: "What's Collected",
        body: 'Personal info, behavioral data, device data, location data, inferred data. Look for "sensitive" categories requiring extra protections.',
      },
      {
        heading: "Purposes",
        body: 'Specific ("fraud detection") is good. Vague ("improve our services") is a blank check.',
      },
      {
        heading: "Sharing",
        body: "Who gets your data and why. Cross-border transfers should reference legal safeguards.",
      },
      {
        heading: "Retention",
        body: "Specific timeframes tied to specific purposes are the gold standard.",
      },
      {
        heading: "Your Rights",
        body: "Access, deletion, portability, opt-out of sale, opt-out of profiling. The policy should tell you exactly how to exercise each.",
      },
      {
        heading: "Controller and Contact",
        body: "Who's legally responsible and how to reach them.",
      },
    ],
    faq: [
      {
        q: "Can I opt out of everything?",
        a: "Some processing is necessary for the contract (billing) and can't be opted out of. Marketing and ad targeting usually can.",
      },
    ],
  },

  // ---------- SAAS RED FLAGS ----------
  {
    slug: "saas-contract-red-flags",
    category: "saas-red-flags",
    title: "10 SaaS Contract Red Flags Buyers Should Reject",
    description:
      "Auto-renewal, uncapped liability, vague SLAs, and data ownership grabs — the SaaS contract clauses to negotiate every time.",
    excerpt:
      "SaaS vendors send the same hostile MSA to every customer. These 10 clauses are the ones to redline.",
    keyword: "SaaS contract red flags",
    tags: ["red-flags", "saas", "auto-renewal", "sla", "data-ownership", "negotiation"],
    readTime: "2 min",
    publishedAt: "2026-04-29",
    updatedAt: "2026-04-29",
    tldr: "SaaS vendors send the same hostile MSA to every customer. Enterprise buyers negotiate it. Small customers often don't realize they can. Here's what to fight.",
    sections: [
      {
        heading: "Auto-renewal with 90-day Notice",
        body: "You will forget. Push for 30 days or remove auto-renewal. Make them earn your renewal.",
      },
      {
        heading: "Uncapped Liability",
        body: "Standard SaaS liability cap is fees paid in prior 12 months. Uncapped is a non-starter for any deal of meaningful size.",
      },
      {
        heading: "No SLA Credits",
        body: "An uptime promise without financial penalties is marketing. Push for 99.9% availability with progressive credits: 10% refund at 99.5%, 25% at 99%.",
      },
      {
        heading: "Vendor Keeps Your Data",
        body: 'On termination, your data should be returned in usable format and permanently deleted. Vendors love to keep "aggregated" or "anonymized" data — narrow or eliminate that.',
      },
      {
        heading: "One-way Indemnification",
        body: 'They should indemnify you for their IP infringement and data breaches too. Make it mutual.\n\nPRICE ESCALATION OVER 7% PER YEAR — Cap renewal increases at CPI or 5-7%. Unchecked, your $50K contract becomes $75K in three years.\n\nVAGUE "FAIR USE" — If the vendor has sole discretion to define abuse, they can throttle or terminate whenever. Get specific thresholds.',
      },
    ],
    faq: [
      {
        q: "Can I negotiate as a small customer?",
        a: "Less leverage on price, but legal terms are usually negotiable regardless of deal size. Worst they can say is no.",
      },
    ],
  },

  // ---------- SAAS EXPLAINED ----------
  {
    slug: "saas-contract-explained",
    category: "saas-explained",
    title: "SaaS Contracts Explained: MSA, Order Form, SLA, DPA",
    description:
      "What each SaaS contract document does — Master Service Agreement, Order Form, SLA, DPA — and how they interact.",
    excerpt:
      "A SaaS deal is usually four documents. Each one carries different risk. Here's what each is for.",
    keyword: "SaaS contract explained",
    tags: ["explained", "saas", "msa", "sla", "dpa"],
    readTime: "2 min",
    publishedAt: "2026-04-29",
    updatedAt: "2026-04-29",
    tldr: "A SaaS deal is usually four documents. Knowing which is which saves you from negotiating the wrong thing.\n\nMASTER SERVICE AGREEMENT (MSA) — The legal framework. Negotiate once, reuse across orders. Covers liability caps, IP ownership, confidentiality, indemnification, termination, governing law. This is where the real risk lives.",
    sections: [
      {
        heading: "Order Form",
        body: "Product, quantity, term, price, billing frequency. Per deal. Short and explicit. Don't let legal terms creep in — that's the MSA's job.\n\nSERVICE LEVEL AGREEMENT (SLA) — Uptime commitments (target 99.9%), measurement methodology, exclusions for planned maintenance, credits when missed. No credits = no teeth.\n\nDATA PROCESSING ADDENDUM (DPA) — Required when processing personal data of EU/UK residents under GDPR. Also useful for CCPA. Covers sub-processors, security measures, breach notification, audit rights.",
      },
    ],
    faq: [
      {
        q: "Do I need a DPA as a small company?",
        a: "If you have any EU/UK customers, yes. Most vendors provide one pre-signed.",
      },
    ],
  },

  // ---------- INDEPENDENT CONTRACTOR TEMPLATES ----------
  {
    slug: "independent-contractor-agreement-template",
    category: "contractor-templates",
    title: "Independent Contractor Agreement Template (Free)",
    description:
      "A clean independent contractor agreement template with proper classification, payment, IP, and termination terms.",
    excerpt:
      "A 5-page contractor agreement that holds up under IRS classification scrutiny and protects both parties.",
    keyword: "independent contractor agreement template",
    tags: ["template", "freelance", "ip", "payment", "termination"],
    readTime: "2 min",
    publishedAt: "2026-04-30",
    updatedAt: "2026-04-30",
    tldr: 'This template handles the single biggest risk in contractor relationships: misclassification. If the IRS, DOL, or your state determines your "contractor" was actually an employee, you owe back taxes, penalties, and benefits.',
    sections: [
      {
        heading: "Key Sections",
        body: "Clear independent contractor status with no benefits. Scope per SOW. IP ownership on payment. Mutual confidentiality. Termination for cause and convenience. Proper 1099 and W-9 handling.",
      },
      {
        heading: "Tax Forms",
        body: "For U.S. contractors paid $600+ in a year, issue a 1099-NEC. Collect a W-9 before the first payment — chasing it months later is a headache.",
      },
    ],
    faq: [
      {
        q: "What makes someone a contractor vs employee?",
        a: "Multi-factor tests from IRS, DOL, and states. Key factors: who controls the work, who provides tools, whether the worker can take other clients, and whether the relationship is project-based or ongoing. The agreement helps but behavior matters more.",
      },
    ],
  },
  {
    slug: "international-contractor-template",
    category: "contractor-templates",
    title: "International Contractor Agreement Template (Free)",
    description:
      "An international contractor agreement template covering payment in USD, IP under U.S. law, and tax responsibility.",
    excerpt:
      "Hiring a contractor in another country means different taxes, currencies, and IP rules. This template handles all three.",
    keyword: "international contractor agreement template",
    tags: ["template", "freelance", "ip", "payment"],
    readTime: "2 min",
    publishedAt: "2026-04-30",
    updatedAt: "2026-04-30",
    tldr: "Hiring internationally adds layers: different tax systems, different IP laws, currency risk. This template handles the major ones.",
    sections: [
      {
        heading: "Tax Forms",
        body: "Use W-8BEN (individual) or W-8BEN-E (entity) for non-U.S. contractors. Certifies foreign status, eliminates U.S. withholding obligations in most cases. Get it before the first payment.",
      },
      {
        heading: "IP Under U.S. Law",
        body: "Many countries (especially EU) have moral rights that survive assignment. Govern under U.S. law and include explicit waiver language where local law permits.",
      },
      {
        heading: "Permanent Establishment Risk",
        body: "A long-term contractor working exclusively for your company can create a tax presence for you in their country. Specify they may serve other clients. Then make sure they actually do, or at minimum, have the right to.",
      },
      {
        heading: "Currency",
        body: "Pay in USD or specify a fixed exchange rate at signing. If the rate moves 10% between signing and payment, someone's unhappy.",
      },
    ],
    faq: [
      {
        q: "Can I pay in their local currency?",
        a: "Yes, but USD with a fixed FX rate at signing avoids disputes.",
      },
    ],
  },

  // ---------- COMMERCIAL LEASE RED FLAGS ----------
  {
    slug: "commercial-lease-red-flags",
    category: "commercial-lease-red-flags",
    title: "10 Commercial Lease Red Flags Small Businesses Always Miss",
    description:
      "Personal guarantees, CAM creep, percentage rent, and missing exclusive-use clauses — the commercial lease red flags to refuse.",
    excerpt:
      "Commercial leases are negotiated, but only if you ask. These 10 clauses are the ones that quietly cost small businesses the most.",
    keyword: "commercial lease red flags",
    tags: ["red-flags", "commercial-lease", "personal-guarantee", "cam", "negotiation"],
    readTime: "2 min",
    publishedAt: "2026-04-30",
    updatedAt: "2026-04-30",
    tldr: "Commercial leases are negotiable. Everything is negotiable. Most small business owners don't know that.",
    sections: [
      {
        heading: "Unlimited Personal Guarantee",
        body: 'You\'re personally on the hook. Negotiate to a "good guy" guarantee: liability ends when you vacate and return keys, even if rent remains under the lease term.',
      },
      {
        heading: "Uncapped CAM Increases",
        body: "Common Area Maintenance charges can balloon. Cap at 5% per year over base year. Exclude capital improvements and management fees over 15%. Require annual reconciliation with audit rights.",
      },
      {
        heading: "Missing Exclusive Use",
        body: "If you run a coffee shop, the lease should bar the landlord from renting to another coffee shop in the same center. Without it, your competitor opens next door next month.",
      },
      {
        heading: "Percentage Rent on Gross Sales",
        body: "If you pay extra on sales above a threshold, exclude refunds, taxes, and online sales not from the physical location.",
      },
      {
        heading: "Assignment Requiring Consent Without Standards",
        body: 'Add: "Consent shall not be unreasonably withheld, conditioned, or delayed." Without this, the landlord can block assignment for any reason — including blocking the sale of your business.',
      },
    ],
    faq: [
      {
        q: "Do I need a broker?",
        a: "Tenant-rep brokers help small businesses. The landlord usually pays the commission, so it costs you nothing.",
      },
    ],
  },

  // ---------- COMMERCIAL LEASE EXPLAINED ----------
  {
    slug: "commercial-lease-explained",
    category: "commercial-lease-explained",
    title: "Commercial Lease Explained: Triple-Net, Gross, CAM, TI",
    description:
      "What every commercial lease term means — gross vs net, CAM, TI allowances, percentage rent, and assignment rights.",
    excerpt:
      "Commercial leases use different vocabulary than residential. Here's the glossary every founder needs.",
    keyword: "commercial lease explained",
    tags: ["explained", "commercial-lease", "cam", "ti-allowance"],
    readTime: "2 min",
    publishedAt: "2026-04-30",
    updatedAt: "2026-04-30",
    tldr: "Residential and commercial leases use different vocabulary. Here's the translation.",
    sections: [
      {
        heading: "Gross vs Net",
        body: "Gross: rent includes operating expenses. Modified gross: rent plus some expenses. Triple net (NNN): rent plus taxes, insurance, and CAM. Most retail and office is NNN — it can add 30-50% to base rent. Know which you're signing.",
      },
      {
        heading: "CAM",
        body: "Common Area Maintenance. Your share of shared spaces: parking lots, hallways, landscaping. Cap increases, exclude capital improvements, reserve audit rights.",
      },
      {
        heading: "TI Allowance",
        body: "Tenant Improvement allowance from the landlord to build out your space. Negotiated per square foot. Get contractor estimates before signing so you're not underfunded.",
      },
      {
        heading: "Percentage Rent",
        body: "Common in retail. Base rent plus a percentage of sales above a threshold. Negotiate the threshold and what's excluded.",
      },
      {
        heading: "Assignment and Subletting",
        body: 'Your right to transfer the lease when you sell the business. Always include "consent shall not be unreasonably withheld."',
      },
    ],
    faq: [
      {
        q: "Should I sign a personal guarantee?",
        a: 'Often required for new businesses. Negotiate a limited "good guy" guarantee or a burn-down where the amount decreases over time.',
      },
    ],
  },

  // ---------- COMMERCIAL LEASE TEMPLATES ----------
  {
    slug: "commercial-lease-loi-template",
    category: "commercial-lease-templates",
    title: "Commercial Lease Letter of Intent (LOI) Template — Free",
    description:
      "A non-binding letter of intent template for commercial leases — pin down rent, term, TI, and key terms before legal work begins.",
    excerpt: "Negotiate the deal in a 1-page LOI before a 60-page lease lands on your desk.",
    keyword: "commercial lease LOI template",
    tags: ["template", "commercial-lease", "loi", "ti-allowance"],
    readTime: "2 min",
    publishedAt: "2026-04-30",
    updatedAt: "2026-04-30",
    tldr: "Before a 60-page lease lands on your desk, negotiate the deal in a one-page LOI. Mostly non-binding — a handshake in writing — but it locks in key business terms so lawyers can't re-open them later.",
    sections: [
      {
        heading: "What It Captures",
        body: "Premises, term length, base rent plus escalations, any free rent, TI allowance ($ per sq ft), CAM cap and exclusions, exclusive use, assignment standard, security deposit, personal guarantee scope.",
      },
      {
        heading: "Why Use One",
        body: "Negotiating in plain English is faster than lease language. Once both sides agree on the deal, the lawyers' job is to faithfully reflect it, not renegotiate it. Without an LOI, every clause in the 60-page draft becomes a new negotiation point.",
      },
      {
        heading: "Binding vs Non-binding",
        body: 'Most provisions are non-binding ("subject to definitive lease"). Two things typically are binding: confidentiality and a 30-day exclusivity period. Clearly mark which is which.',
      },
    ],
    faq: [
      {
        q: "Is the LOI legally binding?",
        a: "Most provisions aren't — contingent on signing a final lease. But confidentiality and exclusivity usually are binding. Mark them clearly.",
      },
    ],
  },
];

export function getCategory(slug: string) {
  return CATEGORIES.find((c) => c.slug === slug);
}

export function getPostsByCategory(slug: string) {
  return POSTS.filter((p) => p.category === slug);
}

export function getPost(slug: string) {
  return POSTS.find((p) => p.slug === slug);
}

// ---------------------------------------------------------------------------
// SEO helpers
// ---------------------------------------------------------------------------

export const SITE_URL = "https://www.legaldecoder.io";
export const SITE_NAME = "legaldecoder";

function truncate(text: string, max: number): string {
  if (text.length <= max) return text;
  const cut = text.slice(0, max - 1);
  const lastSpace = cut.lastIndexOf(" ");
  return (lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut).trimEnd() + "…";
}

function titleCase(input: string): string {
  return input
    .split(" ")
    .map((w) => (w.length > 2 ? w[0].toUpperCase() + w.slice(1) : w))
    .join(" ");
}

export type PostSeo = {
  /** <title> tag — keyword-led, ≤60 chars, brand-suffixed when room allows. */
  title: string;
  /** Meta description — ≤160 chars, derived from description or TL;DR. */
  description: string;
  /** Absolute canonical URL for the post. */
  canonicalUrl: string;
  /** Absolute Open Graph image URL — generated from title + keyword. */
  ogImage: string;
  /** Primary keyword, normalized for the meta keywords tag. */
  keyword: string;
};

/**
 * Derive per-post SEO fields from the blog title and primary keyword.
 * Each post may override any field via `seoTitle`, `metaDescription`,
 * `canonicalUrl`, or `ogImage`.
 */
export function getPostSeo(post: BlogPost): PostSeo {
  const brand = ` — ${SITE_NAME}`;
  const baseTitle =
    post.seoTitle ??
    (post.title.toLowerCase().includes(post.keyword.toLowerCase())
      ? post.title
      : `${titleCase(post.keyword)}: ${post.title}`);
  const titleWithBrand = baseTitle.length + brand.length <= 60 ? `${baseTitle}${brand}` : baseTitle;
  const title = truncate(titleWithBrand, 60);

  const description = truncate(post.metaDescription ?? post.description ?? post.tldr, 160);

  const canonicalUrl = post.canonicalUrl ?? `${SITE_URL}/blog/${post.category}/${post.slug}`;

  // Default OG image: dynamic generator that renders the title + keyword
  // as a branded share card. No API key required.
  const ogImage =
    post.ogImage ??
    `https://og.tailgraph.com/og?` +
      new URLSearchParams({
        fontFamily: "Inter",
        title: post.title,
        titleTailwind: "text-white font-extrabold text-6xl tracking-tight leading-tight",
        text: post.keyword,
        textTailwind: "text-sky-300 font-semibold text-2xl mt-6 uppercase tracking-widest",
        bgTailwind: "bg-slate-900",
        footer: SITE_NAME,
        footerTailwind: "text-slate-400 text-xl",
        t: post.updatedAt,
      }).toString();

  return { title, description, canonicalUrl, ogImage, keyword: post.keyword };
}

const STOP_WORDS = new Set([
  "the",
  "a",
  "an",
  "and",
  "or",
  "of",
  "to",
  "for",
  "in",
  "on",
  "with",
  "your",
  "you",
  "my",
  "is",
  "are",
  "be",
  "by",
  "at",
  "it",
  "as",
  "lease",
]);

function tokenize(text: string): string[] {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, " ")
    .split(/\s+/)
    .filter((t) => t.length > 2 && !STOP_WORDS.has(t));
}

// Human-friendly labels for tag slugs (used in "why related" microcopy)
const TAG_LABELS: Record<string, string> = {
  "red-flags": "red flags",
  "entry-notice": "entry notice",
  "security-deposit": "security deposits",
  "auto-renewal": "auto-renewal traps",
  arbitration: "arbitration clauses",
  fees: "lease fees",
  negotiation: "negotiation tactics",
  "tenant-rights": "tenant rights",
  "move-out": "move-out rules",
  renewal: "lease renewal",
  "rent-increase": "rent increases",
  "lease-sections": "lease structure",
  rent: "rent terms",
  maintenance: "maintenance duties",
  termination: "termination rules",
  habitability: "habitability law",
  eviction: "eviction protections",
  "late-fees": "late fees",
  "pet-rent": "pet fees",
  template: "template language",
  "month-to-month": "month-to-month leases",
  roommates: "roommate rules",
};

function labelTag(tag: string): string {
  return TAG_LABELS[tag] ?? tag.replace(/-/g, " ");
}

// Thumbnail accent gradients — picked deterministically from category.
const CATEGORY_THUMBS: Record<string, { gradient: string; icon: string }> = {
  "lease-red-flags": { gradient: "from-rose-500/30 via-orange-500/20 to-amber-400/10", icon: "🚩" },
  "lease-explained": { gradient: "from-sky-500/30 via-cyan-400/20 to-teal-400/10", icon: "📖" },
  "lease-templates": { gradient: "from-emerald-500/30 via-teal-400/20 to-lime-400/10", icon: "📄" },
};

export function getThumbnail(post: BlogPost) {
  return CATEGORY_THUMBS[post.category] ?? { gradient: "from-primary/30 to-accent/10", icon: "📑" };
}

export type RelatedPost = {
  post: BlogPost;
  score: number;
  /** Short microcopy explaining why this post is related to the source. */
  reason: string;
  /** Structured match signals, in case the UI wants to render them as chips. */
  matches: { sharedTags: string[]; sharedKeywords: string[]; sameCategory: boolean };
};

/**
 * Recommend related posts using a weighted score:
 *  - Shared tags (subtopics): +3 each
 *  - Shared keyword tokens:   +2 each
 *  - Shared title tokens:     +1 each
 *  - Same category:           +1 (tiebreaker only)
 * Returns scored entries with a "why this is related" reason string.
 */
export function getRelatedPosts(slug: string, limit = 3): RelatedPost[] {
  const source = getPost(slug);
  if (!source) return [];

  const sourceTags = new Set(source.tags ?? []);
  const sourceKeywordTokens = new Set(tokenize(source.keyword));
  const sourceTitleTokens = new Set(tokenize(source.title));

  const scored = POSTS.filter((p) => p.slug !== slug).map((p) => {
    const sharedTags: string[] = [];
    for (const tag of p.tags ?? []) {
      if (sourceTags.has(tag)) sharedTags.push(tag);
    }

    // Require at least one shared tag — keyword/title overlap alone is too noisy.
    if (sharedTags.length === 0) {
      return null;
    }

    let score = sharedTags.length * 3;
    const sharedKeywords: string[] = [];

    for (const tok of tokenize(p.keyword)) {
      if (sourceKeywordTokens.has(tok)) {
        score += 2;
        sharedKeywords.push(tok);
      }
    }
    for (const tok of tokenize(p.title)) {
      if (sourceTitleTokens.has(tok)) score += 1;
    }
    const sameCategory = p.category === source.category;
    if (sameCategory) score += 1;

    const reason = buildReason(sharedTags, sharedKeywords, sameCategory, p.category);
    return {
      post: p,
      score,
      reason,
      matches: { sharedTags, sharedKeywords, sameCategory },
    };
  });

  return scored
    .filter((s): s is RelatedPost => s !== null)
    .sort((a, b) => b.score - a.score)
    .slice(0, limit);
}

function buildReason(
  sharedTags: string[],
  sharedKeywords: string[],
  sameCategory: boolean,
  category: string,
): string {
  if (sharedTags.length >= 2) {
    const labels = sharedTags.slice(0, 2).map(labelTag);
    return `Also covers ${labels[0]} and ${labels[1]}.`;
  }
  if (sharedTags.length === 1) {
    return `Goes deeper on ${labelTag(sharedTags[0])}.`;
  }
  if (sharedKeywords.length > 0) {
    return `Same topic from another angle: ${sharedKeywords.slice(0, 2).join(", ")}.`;
  }
  const cat = getCategory(category);
  if (sameCategory && cat) return `More from ${cat.name}.`;
  return cat ? `Related read in ${cat.name}.` : "Related read.";
}
